export type Song = {
  slug: string
  title: string
  year: number
  tagline: string
  order: number
  /** Public web video path (served from /media/videos) */
  video: string
  /** Second burned film. Used by La Pucelle for the French captions. */
  videoFr?: string
  /** Cover still for catalog + OG (omit when no art yet) */
  cover?: string
  /** Public stream + free MP3 download (when ready) */
  audio?: string
  /** Optional AAC/M4A for iOS */
  audioAlt?: string
  mp3Label?: string
  lyrics: string[]
  /** Lyric sheet shown with the French film. */
  lyricsFr?: string[]
}

/**
 * Full AIAS catalog. Love Me In The Dark leads. The rest is A–Z by title.
 */
export const songs: Song[] = [
  {
    slug: 'solo-tu',
    title: 'Solo Tu',
    year: 2026,
    tagline: 'Home is a kingdom of two.',
    order: 1,
    video: '/media/videos/solo-tu.mp4?v=captioned',
    cover: '/media/covers/solo-tu-frame1.jpg?v=noheader1',
    // Static Pages path (not /media worker) — more reliable on phones
    audio: '/stream/solo-tu.mp3',
    audioAlt: '/stream/solo-tu.m4a',
    mp3Label: 'AIAS - Solo Tu (320kbps).mp3',
    lyrics: [
      'Solo tu',
      'Solo tu',
      'Solo tu',
      "You're the one I came home to",
      "Two hours past midnight and it's still true",
      'Every road leads back to you',
      "You're the one I came home to",
      'Solo tu',
      'Solo tu',
      'Solo tu',
      'Solo tu',
      'Solo tu',
      'Solo tu',
      'Solo tu',
      'Solo tu',
      'Solo tu',
      'Solo tu',
      'Solo tu',
      '2:24',
      '2:42',
      'Winter night felt like a',
      'Texas summer',
      'Beneath that oak tree',
      'Only the moon knew before',
      'I knew',
      'Anima mia',
      'You look at me like that',
      'I forget I ever had a choice',
      'Sei il mio faro',
      'Sei il mio riparo',
      '',
      'Solo tu',
      'Every wrong turn ends in you',
      "You're the one I came home to",
      "Two hours past midnight and it's still true",
      'Every road leads back to you',
      "You're the one I came home to",
      'Every time every time every time',
      'Cuore mio',
      'Every time every time every time',
      '',
      'Cuore mio',
      '',
      'Solo tu',
      'Diecimila volte ma sei tu',
      'Sei',
      'Sei irresistibile',
      "If this is a dream don't you dare wake me",
      'Say my name slow',
      "I'm not going anywhere",
      'Home is a kingdom of two',
      "If that ain't destiny what is",
      "You're the one I came home to",
      "Two hours past midnight and it's still true",
      'Every road leads back to you',
      "You're the one I came home to",
      'Every time every time every time',
      '',
      'Cuore mio',
      'Every time every time every time',
      '',
      'Cuore mio',
      'Solo tu solo tu',
      'Ancora ancora',
      'Per sempre con te',
      '',
      'Solo tu solo tu',
      'Every wrong turn ends in you',
      'Tutte le strade portano a te',
      'Gira e rigira',
      'È sempre così',
      'All my roads end with you',
      '',
      'Anima mia',
      'Winter or Texas summer',
      'A thousand and one nights',
      "I'd spend them all on you",
      'Sei tu sei tu',
      "You're the one I came home to",
      'Ancora, ancora',
      '',
      'Solo tu',
      'Solo tu',
      'Solo tu',
      'The one I came home to',
      '',
      'Solo tu',
      'Solo tu',
    ],
  },
  {
    slug: 'call-me-crazy',
    title: 'Call Me Crazy',
    year: 2026,
    tagline: 'I came home — to me.',
    order: 2,
    video: '/media/videos/call-me-crazy.mp4?v=captioned-20261027',
    cover: '/media/covers/call-me-crazy.jpg?v=noheader1',
    audio: '/stream/call-me-crazy.mp3',
    audioAlt: '/stream/call-me-crazy.m4a',
    mp3Label: 'AIAS - Call Me Crazy (320kbps).mp3',
    lyrics: [
      'Call me crazy',
      'I came home',
      'You ghosted first then called me haunted',
      'You drew the line',
      'I learned to blur it',
      "Saw red flags and called 'em sunset",
      "You said let's keep it light then weighed me down",
      'Said I was home but I came home alone',
      'No title, full-time',
      'I still clocked in',
      'Girlfriend hours no girlfriend when',
      'Put love in the food you just liked the taste',
      'Fed you my soft side you still left the plate',
      'Kept pouring love you called it rain',
      'I called it care you called it pain',
      "People ain't flowers",
      'I know that now',
      "Some take the water still don't know how",
      '',
      'Call me crazy',
      'I came home',
      'Call me crazy, I came home',
      'You ghosted first then called me haunted',
      'Still I came home',
      'Had girlfriend pain with no girlfriend name',
      'Still, I came home',
      'I was sane when I was useful',
      'Sick when I had needs',
      'Asked you for the truth',
      'You said it was pressure on your peace',
      'Locked every door then called my knock a crime',
      'Your pride kept typing then deleting every line',
      'I was grieving a home you kept calling a room',
      'You made almost feel real then said I assumed',
      'I know how that sounds',
      'I hate that it sounds true',
      'My mind knew better',
      'My heart kept receipts',
      'Thought patience was love till it started charging me',
      '',
      "People ain't flowers",
      'I know that now',
      "Love don't make 'em choose",
      'I know that now',
      '',
      'Call me crazy',
      'I came home',
      'Call me crazy, I came home',
      'Had girlfriend pain with no girlfriend name',
      'Still I came home',
      "Unlocked ain't home",
      "Soft don't mean stay",
      'Still I came home',
      'I fed you love you called me hungry',
      'Held your hurt you called me heavy',
      'I miss who I thought you was not who you was',
      "I miss the version of me that ain't know better yet",
      "I ain't waiting by the phone not this time",
      "Built me a place you don't get keys to",
      '',
      'Call me crazy',
      'I came home',
      'Call me crazy',
      'I came home',
      'You ghosted first then called me haunted',
      'Still I came home',
      'Had girlfriend pain with no girlfriend name',
      'Still I came home',
      "I'm not the door no more",
      "I'm the miles now",
      'I came home',
      'I came home',
      'I came home',
      '',
      'Call me crazy',
      'I came home',
      "People ain't flowers",
      'I know that now',
      'I kept pouring then I came home to me just me',
    ],
  },
  {
    slug: 'love-me-in-the-dark',
    title: 'Love Me In The Dark',
    year: 2026,
    tagline: 'Or don’t love me at all.',
    order: 3,
    video: '/media/videos/love-me-in-the-dark.mp4?v=captioned',
    cover: '/media/covers/love-me-in-the-dark.jpg?v=noheader1',
    audio: '/stream/love-me-in-the-dark.mp3',
    audioAlt: '/stream/love-me-in-the-dark.m4a',
    mp3Label: 'AIAS - Love Me In The Dark (320kbps).mp3',
    lyrics: [
      'Dans le noir',
      'Jamais',
      'Bébé, ma nuit',
      'Dans le noir',
      'Jamais',
      'Bébé, ma nuit',
      'Love me in the dark',
      'Phone lit at two my chest went quiet',
      'You sent it twice',
      'I watched it go dark',
      "That ain't cold that's panic with manners",
      'I made my damage sound like depth',
      'I left first and called it mercy',
      'Next to your fire my smoke looked clean',
      'I love you',
      "I don't want you",
      'True and true',
      'I hate myself for both',
      "I didn't leave when love died",
      'I left when your eyes got honest',
      'You gave me light',
      'I made a shadow out of it',
      '',
      'Love me in the dark',
      "Don't say my name outside",
      '',
      'Love me in the dark',
      "I don't do love in light",
      "I don't want your heart",
      'I just want the room you cry in',
      'I want all of you and none of me',
      '',
      'Love me in the dark',
      "Or don't love me at all",
      '',
      'Dans le noir',
      '',
      'Jamais',
      'Mon amour',
      'Ma ruine',
      'Ma nuit',
      '',
      'Love me in the dark',
      'You reached for my hand',
      'I left it hanging',
      "I only touch what I'm losing",
      'Loved the thunder blamed the rain called the silence choosing',
      "You're beautiful but not like that",
      "You're the only one who came for my heart",
      "But light don't know what to do with me",
      'You loved me like I could be forgiven',
      'I loved you like I had a right',
      'I made distance sound like discipline and hid the dark behind the light',
      '',
      "Don't say my name outside",
      '',
      'Love me in the dark',
      "I don't do love in light",
      "I don't want your heart",
      'I just want the room you cry in',
      'I want all of you and none of me',
      '',
      'Love me in the dark',
      "Or don't love me at all",
      'And God forgive me',
      'I liked the proof you stayed',
      'I liked the proof you stayed',
      "I'm sorry",
      "I'm sorry",
      "God, I'm sorry",
      'Sorry',
      'Sorry',
      'Sorry',
      'Sorry',
      'Sorry',
      'I made you',
      'I own you',
      'I broke you',
      'Then blamed you',
      'I called it love when it was leverage',
      'I called it depth when it was damage',
      'You called me home',
      'I called you the problem',
      'You were the best thing that loved me',
      'The dark I kept becoming',
      'I could protect you from the world just not from what I wanted',
      'Cette nuit-là, le bar la porte grise',
      "J'ai dit à bientôt comme on dit jamais",
      "Tu m'as regardé j'ai baissé les yeux",
      'Depuis je regarde la pluie tomber',
      "C'était moi c'était toujours moi",
      "Je le savais je ne t'ai pas méritée",
      'Tu étais mon bébé, mon amour, mon cœur',
      'Tu étais ma vie, ma lumière devenue ma nuit',
      'Après toi je ne reconnais que la nuit',
      '',
      'Love me in the dark',
      '',
      "Don't say my name outside",
      '',
      'Love me in the dark',
      "I don't do love in light",
      "I don't want your heart",
      'I just want the room you cry in',
      'I want all of you and none of me',
      '',
      'Love me in the dark',
      "Or don't love me at all",
      'I knew what you were',
      'I stayed anyway',
      "I'd still kiss you if I saw you",
      "That's why I stay gone",
      "Tu étais ma maison je n'y entre plus",
      "Je t'aime encore je ne reviens plus",
      "Tu as mon amour tu ne m'as plus",
      '',
      'Dans le noir',
      '',
      'Jamais',
      '',
      'Dans le noir',
      '',
      'Jamais',
    ],
  },
  {
    slug: 'fold-your-heart',
    title: 'Fold Your Heart',
    year: 2026,
    tagline: 'Try again. Come correct.',
    order: 4,
    video: '/media/videos/fold-your-heart.mp4?v=captioned',
    cover: '/media/covers/fold-your-heart.jpg?v=noheader1',
    audio: '/stream/fold-your-heart.mp3',
    audioAlt: '/stream/fold-your-heart.m4a',
    mp3Label: 'AIAS - Fold Your Heart (320kbps).mp3',
    lyrics: [
      'There he go',
      'Half a second late with that smile',
      'He ain’t got a clue',
      'Eyes on me like he came to ask permission',
      'Same spot',
      'Same stare',
      'Right on time',
      'I come in round eleven',
      'His eyes on me',
      'Cleaned up and quiet',
      'Playing his little games',
      'He don’t speak much',
      'But baby he burns strong',
      'Not my standards',
      'I don’t run',
      'I don’t chase',
      'I don’t fold',
      'Baby',
      'I make them look up',
      'Baby, that’s just me',
      '',
      'He the loudest quiet I ever had',
      'I don’t chase',
      'I don’t beg',
      'I don’t fold',
      'He keep circling back to a love he already know',
      'He already know',
      'Baby he already know',
      '',
      'Fold your heart',
      'Send it back',
      'Try again',
      'Come correct',
      'Baby',
      'Try again',
      'Baby',
      'Watching me',
      'Playing games',
      'I know when he lyin',
      'When he scared',
      'When he cravin me',
      'Baby you ain’t never got one on me',
      'You ain’t got nothing on me',
      '',
      'He the loudest quiet I ever had',
      'I don’t chase',
      'I don’t beg',
      'I don’t fold',
      'He keep circlin back to a love he already know',
      'He already know',
      'Baby he already know',
      '',
      'Fold your heart',
      'Send it back',
      'Try again',
      'Come correct',
      'Baby',
      'Try again',
      'Baby',
      '',
      'Fool me twice',
      'No baby in your dreams',
      'Lose me',
      'That’s on you',
      'Love me',
      'You might become my sweet boy',
      'Why can’t you just let me go',
      'Go away',
      'Leave me alone',
      'Ain’t that what you thought',
      'I wanted to hear',
      'Bless your heart',
      'I said go to see if you knew how to stay',
      'Write me letters',
      'Put your words on paper',
      'I will fold your heart',
      'Send it back',
      'And still say try again',
      'Come back stronger',
      'Kiss my neck',
      'Say nothing',
      'Let that tension speak',
      'You soft with me',
      'I love soft when I’m safe',
      'Make me feel heard',
      'Make me feel seen',
      '',
      'Attends mon cœur',
      'Viens un peu plus près',
      'J’ai envie de toi',
      'Là, maintenant',
      'Jusqu’à l’aube',
      'Et tous les jours',
      'Je t’aime',
      'Je te veux',
      'Je te choisis',
      'Je reste ici',
      'Toujours',
      'Je le redis maintenant',
      'Je le redis demain',
      'Et je le redis chaque fois',
      'C’est toi',
      'Et ce sera toujours toi',
      '',
      'Rien que nous deux',
      'On oublie tout',
      'J’ai envie de vivre avec toi',
      'Tu me calmes',
      'C’est toi',
      '',
      'Ça a toujours été toi',
      '',
      'He the loudest quiet I ever had',
      'I don’t chase',
      'I don’t beg',
      'I don’t fold',
      'He keep circling back to a love he already know',
      'He already know',
      'Baby he already know',
      '',
      'Fold your heart',
      'Send it back',
      'Try again',
      'Come correct',
      'Baby',
      'Try again',
      'Try again',
      'Baby',
      '',
      'Texas gold',
      'Tyler girl',
      'Ink on her arm',
      'Soul tie with a promise ring',
      'A reminder we get to be happy',
      'My love',
      'My love',
      'My sweet boy',
    ],
  },
  {
    slug: 'gold-in-the-flame',
    title: 'Gold In The Flame',
    year: 2026,
    tagline: 'I made my own name.',
    order: 5,
    video: '/media/videos/gold-in-the-flame.mp4?v=captioned',
    cover: '/media/covers/gold-in-the-flame.jpg?v=noheader1',
    audio: '/stream/gold-in-the-flame.mp3',
    audioAlt: '/stream/gold-in-the-flame.m4a',
    mp3Label: 'AIAS - Gold In The Flame (320kbps).mp3',
    lyrics: [
      'Ghost on paper flesh in the flame',
      'You never said my name',
      'I made my own name',
      'Oh oh yeah',
      'Oh',
      'Yeah',
      'Mm',
      'I called it destiny you called it Tuesday same bed, same silence same excuse to leave',
      'How do you grieve someone you never had',
      'How do you miss a love that never got to breathe',
      "I was the window you closed now I'm the wind",
      "You couldn't keep me out couldn't keep me in",
      'Ghost on paper flesh in the flame',
      '',
      'You never said my name',
      '',
      'I made my own name',
      'Own name, own name',
      '',
      'I made my own name',
      'Own name own name',
      '',
      'I made my own name',
      '',
      'Mm',
      "I don't need your reasons now",
      "I can't mourn what was never mine",
      "I can't force what never was",
      'Nobody answered my 3 AM',
      "I was the window you closed now I'm the wind",
      "You couldn't keep me out couldn't keep me in",
      'Ghost on paper flesh in the flame',
      '',
      'You never said my name',
      '',
      'I made my own name',
      '',
      'Own name, own name',
      '',
      'I made my own name',
      '',
      'Own name, own name',
      '',
      'I made my own name',
      'Ooh mm',
      "Go shine you're still the sun",
      'I saw your light, it was real',
      'Not every flame leaves a scar',
      'Some just show you who you really are',
      'That smile looks good on you',
      'Ooh',
      'And this freedom looks good on me',
      "I was the window you closed now I'm the wind",
      "You couldn't keep me out couldn't keep me in",
      'I hope you heal',
      'I hope you bloom',
      'I hope the garden forgives the room',
      'Ghost on paper gold in the flame',
      '',
      'I made my own name',
      'Name',
      'Ghost on paper',
      '',
      'Oh',
      'Gold in the flame',
      '',
      'You never said my name',
      '',
      'I made my own name',
    ],
  },
  {
    slug: 'fourth-of-july',
    title: 'Fourth of July',
    year: 2026,
    tagline: "Don’t play with it.",
    order: 6,
    video: '/media/videos/fourth-of-july.mp4?v=captioned',
    cover: '/media/covers/fourth-of-july.jpg?v=noheader1',
    audio: '/stream/fourth-of-july.mp3',
    audioAlt: '/stream/fourth-of-july.m4a',
    mp3Label: 'AIAS - Fourth of July (320kbps).mp3',
    lyrics: [
      "Don't play with it",
      'Fourth of July',
      'Mm',
      'Fourth of July you finally slid through',
      "Fireworks loud but I'm locked on you",
      'Big crush, grown now',
      "Don't act brand new",
      "Been eyein' me",
      'I been peeped it too',
      'Say less, baby',
      'I like that mood',
      "You frontin' but I feel it",
      'Tryna play cool',
      "But you leanin' my way",
      'Keep it hush',
      "Don't kill the vibe",
      'Step in close',
      'Look me in my eye',
      'Look me in my eye',
      '',
      "Don't play with it",
      'You know what it is',
      'One hand at my neck',
      'Other hand on my hip',
      'Keep it quiet',
      'Let the bass get low',
      'No more almost, baby',
      'Show me right now',
      "Don't play, don't play",
      "Don't play with it",
      'Low voice, slow hands',
      'Put that on me',
      "Don't play, don't play",
      "Don't play with it",
      'No more almost',
      'Show me then',
      '',
      'Hands stay low but the grip stays heavy',
      'Room got hot when you stepped to me',
      "Sweatin' through silk and you ain't even touch me",
      "Ain't gotta say it",
      'Let your body speak',
      "Eyes been talkin'",
      "I been listenin'",
      "Been a long time comin'",
      "Don't waste it",
      "Don't come perfect",
      'Come with pressure',
      'If you want it',
      'Put it on me',
      'Say less',
      'I been peeped it',
      "Don't just look",
      'Show me then',
      'Show me then',
      '',
      "Don't play with it",
      'You know what it is',
      'One hand at my neck',
      'Other hand on my hip',
      'Keep it quiet',
      'Let the bass get low',
      'No more almost, baby',
      'Show me right now',
      "Don't play, don't play",
      "Don't play with it",
      'Low voice, slow hands',
      'Put that on me',
      "Don't play, don't play",
      "Don't play with it",
      'No more almost',
      'Show me then',
      '',
      'Close that door',
      'Leave the party outside',
      'Ceiling mirror',
      'Keep your eyes on mine',
      'Been a long time',
      "Don't waste my night",
      "Fireworks poppin' but the fuse right here",
      "Ain't gotta say it",
      'Just show me',
      'One hand at my neck',
      '',
      "Don't play with it",
      'If you want it, baby',
      'Show me then',
      '',
      "Don't play with it",
      'You know what it is',
      'One hand at my neck',
      'Other hand on my hip',
      'Keep it quiet',
      'Let the bass get low',
      'No more almost, baby',
      'Show me right now',
      "Don't play, don't play",
      "Don't play with it",
      'Low voice, slow hands',
      'Put that on me',
      'Big crush, grown now',
      "Don't act brand new",
      "Don't play with it",
      '',
      'Mm',
      'Show me then',
      "Don't play with it",
      "Don't play",
      'Show me then',
    ],
  },
  {
    slug: 'back-to-me',
    title: 'Back To Me',
    year: 2026,
    tagline: 'Come back to me.',
    order: 7,
    video: '/media/videos/back-to-me.mp4?v=captioned',
    cover: '/media/covers/back-to-me.jpg?v=noheader1',
    audio: '/stream/back-to-me.mp3',
    audioAlt: '/stream/back-to-me.m4a',
    mp3Label: 'AIAS - Back To Me (320kbps).mp3',
    lyrics: [
      'I don\'t miss you.',
      'I miss who I was.',
      'Before I gave myself away.',
      'I don\'t miss you.',
      'I miss who I was.',
      'Before I gave myself away.',
      'I thought you were peace,',
      'I was only quiet.',
      'I disappeared slow,',
      'now I hear me louder.',
      'Back to me, back to me.',
      'I came all the way back to me.',
      'Windows down, I can breathe.',
      'Not bitter, just better with me.',
      'Back to me, back to me.',
      'I found who I was with the',
      'windows down. Back to me,',
      'back to me.',
      'I found who I was and I like me',
      'now. Back to me, back to me.',
      'Oh.',
      'I gave you every exit.',
      'Took the wrong turn twice,',
      'then a hundred more.',
      'You called me strange,',
      'I still gave grace,',
      'kept opening doors.',
      'You didn\'t steal my heart,',
      'I kept handing it over.',
      'Lost my reflection,',
      'trying to make you closer.',
      'Then the light came through,',
      'and it looked like truth.',
      'I was never gone,',
      'I was waiting on me.',
      'I knew the whole time,',
      'I stayed anyway.',
      'The bravest thing I did',
      'was finally leave.',
      'You weren\'t my safety,',
      'you were the dead end',
      'I kept taking.',
      'Like love was waiting',
      'there for me.',
      'I don\'t miss you,',
      'I miss who I was.',
      'Before I gave myself away.',
      'I thought you were peace,',
      'I was only quiet.',
      'I disappeared slow,',
      'now I hear me louder.',
      'Back to me, back to me,',
      'I came all the way.',
      'Back to me, back to me,',
      'windows down. Back to me, back,',
      'back to me,',
      'I found who I was with the',
      'windows down. Back to me, back,',
      'back to me.',
      'I found who I was and',
      'I like me now.',
      'You knew how to touch me,',
      'never learned how to hold me.',
      'Ooh-ooh. Knew where I was soft,',
      'never tried to know me.',
      'I showed you the parts',
      'nobody else sees.',
      'You wanted the access,',
      'I needed the peace.',
      'No hard feelings,',
      'just hard truth.',
      'I had to lose us to',
      'come back new.',
      'No more shrinking to fit your',
      'room. I take up space now.',
      'I like the view.',
      'I don\'t need a rescue,',
      'I need something steady.',
      'Someone who can hear my silence,',
      'and not make it heavy.',
      'I forgive the girl who',
      'stayed too long.',
      'She was doing her best',
      'with a broken song.',
      'Now I roll the top down,',
      'let my hair flow.',
      'If I had to lose you,',
      'at least I came home.',
      'I don\'t miss you,',
      'I found who I was.',
      'Before I gave',
      'myself away.',
      'I thought you were peace,',
      'I was only quiet.',
      'I disappeared slow,',
      'now I hear me louder.',
      'Back to me, back to me,',
      'I came all the way',
      'back to me.',
      'Back to me, back, back to me.',
      'I found who I was',
      'with the windows down.',
      'Back to me, back, back to me.',
      'Oh,',
      'I don\'t miss you. Back,',
      'back to me. I found who I was.',
      'I don\'t miss you. Back,',
      'back to me.',
      'Oh. Yeah.',
      'I don\'t miss you.',
    ],
  },
  {
    slug: 'black-diamond',
    title: 'Black Diamond',
    year: 2026,
    tagline: 'Cut deep.',
    order: 8,
    video: '/media/videos/black-diamond.mp4?v=captioned',
    cover: '/media/covers/black-diamond.jpg?v=noheader1',
    audio: '/stream/black-diamond.mp3',
    audioAlt: '/stream/black-diamond.m4a',
    mp3Label: 'AIAS - Black Diamond (320kbps).mp3',
    lyrics: [
      'Fourth level',
      'Dallas bar',
      'Black diamonds dance',
      'Beauty you are',
      'Sexy with a double SSSSSSS',
      'Silk Satin frame',
      'Curves takin’ the room',
      'Girl side-eyein’',
      'What she got that I don’t',
      'Don’t know your name',
      'I’m already movin’',
      'Claimin’ that prize',
      '',
      'Fourth level',
      'Black Diamonds',
      'Dance in a trance',
      'Silk satin silhouette',
      'Foreign language at a glance',
      'Three down, fourth waitin’',
      'Name of the pour escaped my mind',
      'Edge of the seat Breath held',
      'Body locked and loaded',
      'Past midnight',
      'Still in the heat',
      'Claimin’ that prize What’s under that satin',
      'Bottle service runnin’',
      'VIP already know',
      'Cigars low',
      'Algebra out the window',
      'Eye contact locked',
      'Club lights up',
      'Heartbeat on attack',
      '',
      'Beauty you are',
      'Sexy with a double SSSSS',
      '',
      'Don’t know your name',
      '',
      'Claimin’ that prize',
      '“I forgot the name” Messin’ with my brain',
      'Is she callin’ my name',
      'To the beat she dances',
      'What’s algebra right now',
      'Lost the count',
      'She’s over there I’m right here',
      'Gin messin’ my brain',
      'Like a smokeless djinn Temptin’ sin',
      'Blasphemy dipped in gold',
      'Eve with a Medusa stare',
      'I ain’t delusional I’m the zealot, baby the ZEALOT, baby',
      'Turned to salt if I look back',
      'Already movin’ for the seat',
      'Club closin’ fast',
      'What’s your name',
      'Where you goin’',
      'One time',
      'Come closer',
      '',
      'I’m already movin’',
      '',
      'Claimin’ that prize',
      '',
      'Blasphemy dipped in gold',
      '',
      'Eve with a Medusa stare',
      'Prrrrrrrrrrrrrr',
      'Under that satin',
      'Pam pam pam',
      'One call Heartbeat risin’',
      'I’m the zealot, baby',
      '',
      'What’s your name',
      'Where you from',
      'Where you goin’',
      'Where you goin’',
      'The zealot, baby',
    ],
  },
  {
    slug: 'go-away',
    title: 'Go Away',
    year: 2026,
    tagline: 'Leave — or stay.',
    order: 9,
    video: '/media/videos/go-away.mp4?v=captioned',
    cover: '/media/covers/go-away.jpg?v=noheader1',
    audio: '/stream/go-away.mp3',
    audioAlt: '/stream/go-away.m4a',
    mp3Label: 'AIAS - Go Away (320kbps).mp3',
    lyrics: [
      "You think I saw it 'cause your phone said",
      '"delivered."',
      "Down in Texas we don't just cut you",
      "I flip the switch so fast your neck snaps watchin' me leave",
      'Shh keep my name out your mouth',
      "I-I-I-I got eyes everywhere out listenin'",
      "Catch him runnin' his mouth now he deader than me",
      'Everybody know my whip',
      'I stay low at the crib',
      "Niggas stalkin' my inbox wantin' that smoke",
      "You sittin' in the dark but I see it all",
      'I know who you fuck who you text who you do who you call',
      'Blocked but not read my baby who owns who',
      "I'm a whole different woman every room",
      'I switch faces on command',
      "Bitches wonder how I got you this obsessed while you sittin' on mute",
      'Nobody gets me like you',
      'Nobody gets me but you',
      "I used to pray you'd stop carin' now I got you blocked on everything",
      'Toxic, yeah still want your eyes on me',
      "He wasn't ever really mine",
      "Had me chasin' had me trippin'",
      'He was too soft too grateful too easy too available too forgettable',
      'I wanted that hush hush',
      "Spittin' back shit leave me feelin' hard",
      "Sweet-talkin' rent-a-swagger don't hit the same",
      'My nigga kinda love that wounds before it heals',
      "Got me stuck in that pen like pain chasin' the feels",
      "He did that then slipped right back to that same old washed bitch and left my chest on read like I was nothin'",
      'Like I was never here',
      'Honest ride',
      "I can't take all this",
      "Phone blowin' up but the vibe ain't worth the fit",
      "Phone on DND charger gone brain still racin'",
      'Every damn year',
      "I tell myself I don't give a leave me move on",
      'G-g-g-g-g-go go away',
      'G-g-g-g-g-go',
      'G-g-g-g-g-go go away',
      'Why you still stuck on my ass',
      'Get get off my back',
      "Don't call me",
      "Don't pull up",
      "Don't wait",
      'Truth is',
      'I do love you',
      "Je t'aime vraiment mais va-t-en",
      'But I need you gone',
      'G-g-g-g-go away',
      'G-g-g-g-g-go go away',
      'G-g-g-g-g-go go away go away',
      'G-g-g-g-g-go go away',
      'G-g-g-g-g-go away',
      'I keep a roster on everybody my phone a graveyard',
      'With the same old thirst',
      'My clients my shadows my ghosts they never miss',
      'I got them all but I want none',
      "I-I-I'm the prize",
      'I hand nobody the crown',
      'The spot the rush the ruin the whole damn drug',
      'One look',
      'I make your whole body switch tempo off a glance',
      "I give the orders ain't even gotta use my hands",
      "I'm with the rebound shit right now",
      'Knew it was dead from jump',
      "I be clockin' exits before I even sit down",
      'You handed me your soul',
      'I handed you a script',
      '',
      'Truth is',
      'I burned you just to save myself',
      'Still stuck on that ghost',
      'Hold it when it finally got real',
      'Tossed me out like trash',
      'Still',
      "I'm the baddest he gon' feel",
      'I opened up',
      'I let it out',
      "Told my family what I'm about",
      'I post, I film',
      'I chase the views',
      'Get off my page',
      "Beggin' for the timeline way easier than tellin' the truth",
      "I don't know why",
      'I tell people so much',
      '',
      "I don't know why",
      'I cry when I talk about my life',
      "The shit is gone and I'm out here beggin' the universe to bring him back",
      'Pas toi',
      "J'aime toi",
      'They left and I turned him into a ghost',
      "Now I'm the one bein' haunted",
      "I'm not askin'",
      "I'm tellin' you what it is",
      'Every time it get too real',
      'I flip out and wreck it myself',
      'Soon as they settle in',
      'I get gone',
      'Soon as somebody love me right',
      'I ghost first and call it fate',
      'Leave me move on go away',
      "That's what I scream when it get too real",
      '',
      'Truth is',
      '',
      'I do love you',
      '',
      "Je t'aime vraiment mais va-t-en",
      "B-b-but I can't let you stay right here",
      'Go away',
      "I know somethin' wrong with me",
      'Real talk',
      'I knew from jump',
      'B-b-b-b-b-b-b-b-bummer',
      "I'm the common denominator",
      'Me',
      'I know that',
      "I just don't know why bein' wanted make me itch and bein' left make me bleed",
      "I'm tired but I still confuse destruction with relief",
      "Keep choosin' the storm callin' the calm a dark disbelief",
      "I just don't know what to do with the quiet when it's done",
      "They don't tell you that the prize is a pretty empty room",
      "And all that love I'm chasin' is a ghost I can't exhume",
    ],
  },
  {
    slug: 'heart-racing',
    title: 'Heart Racing',
    year: 2026,
    tagline: 'Can\'t slow down.',
    order: 10,
    video: '/media/videos/heart-racing.mp4?v=captioned',
    cover: '/media/covers/heart-racing.jpg?v=noheader1',
    audio: '/stream/heart-racing.mp3',
    audioAlt: '/stream/heart-racing.m4a',
    mp3Label: 'AIAS - Heart Racing (320kbps).mp3',
    lyrics: [
      'Standing and falling',
      'feel the same at first.',
      'The difference is who\'s countin\'',
      'the beats.',
      'The air went thin in the',
      'first half-second.',
      'Heart racing — and I',
      'knew the rhythm.',
      'Days turned to months holdin\'',
      'on to a promise',
      'I called it love',
      'But love don\'t make you',
      'beg for breath',
      'Love don\'t keep the score',
      'My body knew before',
      'my mind would',
      'what the racing was for.',
      'That wasn\'t love.',
      'That was grief.',
      'That was anguish.',
      'All wearin\' his name.',
      'Heart racing —',
      'I called it love!',
      '\'Cause it hurt so',
      'much to want him!',
      'Heart racing —',
      'I called it love!',
      '\'Cause the wantin\' wouldn\'t end!',
      'Love don\'t beg for breath',
      'at midnight!',
      'Your silence was a kind of lie!',
      'Heart racing —',
      'I called it love!',
      'But it was panic wearin\'',
      'his name!',
      'I\'m not the woman you leave in',
      'increments. Piece by piece,',
      'you thought I wouldn\'t notice.',
      'I negotiated with myself',
      'in the dark.',
      'Gave up my gravity to keep you',
      'Kept the fire burnin\'',
      'It fed you and swallowed',
      'me whole.',
      'I thought love was',
      'supposed to ache',
      'I confused the leash',
      'with the embrace',
      'But the body has a memory',
      'And it never once called this',
      'safe.',
      'Heart racing —',
      'I called it love!',
      '\'Cause it hurt so',
      'much to want him!',
      'Heart racing —',
      'I called it love!',
      '\'Cause the wantin\' wouldn\'t end!',
      'Love don\'t beg for breath',
      'at midnight!',
      'Your silence was a kind of lie!',
      'Heart racing —',
      'I called it love!',
      'But it was panic wearin\'',
      'his name!',
      'I forgave him — God, I do',
      'And forgivin\' me?',
      'That opened the sky',
      'I walked to the edge of',
      'everything we were and the',
      'wind came up to meet me',
      'I always thought the racing',
      'meant afraid',
      'Then the ground let go —',
      'and I wasn\'t falling',
      'I stopped falling.',
      'Same heart.',
      'Same kindness. Different sky.',
      'I don\'t know where I\'m goin\'',
      'So let the sun do its worst —',
      'These wings ain\'t wax.',
      'Heart racing...',
      'Heart racing... Heart racing —',
      '\'cause I\'m flying now!',
      'Heart racing —',
      'and it don\'t mean run!',
      'This is what the rhythm',
      'was rehearsin\' for —',
      'The fall was just the takeoff!',
      'Heart racing — same heart,',
      'brand new sky!',
      'And the sky was waitin\' on me!',
      'Heart still racing.',
      'Heart racing...',
      'But now it\'s just the wind.',
    ],
  },
  {
    slug: 'i-can-breathe',
    title: 'I Can Breathe',
    year: 2026,
    tagline: 'Out loud this time.',
    order: 11,
    video: '/media/videos/i-can-breathe.mp4?v=captioned-20261027',
    cover: '/media/covers/i-can-breathe.jpg?v=20261001',
    audio: '/stream/i-can-breathe.mp3',
    audioAlt: '/stream/i-can-breathe.m4a',
    mp3Label: 'AIAS - I Can Breathe (320kbps).mp3',
    lyrics: [
      'I done messed up',
      "I ain't whispering it this time",
      'You said just breathe',
      'And it hit',
      'I come back to me',
      'You got me out my head',
      'Back in my body',
      'I stay',
      'I stay',
      'Loving you without permission',
      '',
      'Out loud this time',
      'I choose you',
      'I can breathe',
      'I can breathe',
      'Out loud this time',
      'I choose you',
      'I can breathe',
      '',
      'I left you in the dark',
      'Walking blind into walls',
      "You ain't even want better",
      'You just wanted me better',
      'That hit me late',
      "That's on me",
      'I stand',
      'I stand',
      'Loving you without permission',
      'I can want you',
      'And still keep me',
      '',
      'Out loud this time',
      'I choose you',
      'I can breathe',
      'Out loud this time',
      'I choose you',
      'I can breathe',
      '',
      'I can want you',
      'And still keep me',
      '',
      'Out loud this time',
      'I choose you',
      'I can breathe',
      'Out loud this time',
      'I choose you',
      'I can breathe',
      '',
      'I can want you',
      'And still keep me',
      'I love you',
      '',
      'Out loud this time',
    ],
  },
  {
    slug: 'i-love-me-more',
    title: 'I Love Me More',
    year: 2026,
    tagline: 'I choose me.',
    order: 11,
    video: '/media/videos/i-love-me-more.mp4?v=captioned',
    cover: '/media/covers/i-love-me-more.jpg?v=noheader1',
    audio: '/stream/i-love-me-more.mp3',
    audioAlt: '/stream/i-love-me-more.m4a',
    mp3Label: 'AIAS - I Love Me More (320kbps).mp3',
    lyrics: [
      'Mmm',
      'No tiene precio',
      'No, no',
      'I love me more',
      'I love me more',
      'I love me more',
      'I love me more',
      'Mi dignidad no tiene precio',
      'No, no',
      "I don't chase what don't choose me",
      'Con amor se acabó',
      'Se acabó',
      'And',
      '',
      'I love me more',
      'More, more',
      'Say it loud',
      '',
      'I love me more',
      'More',
      "Soft life locked ain't openin' the door",
      'Woo',
      '',
      'I love me more',
      'I love me more',
      '',
      'Mi dignidad no tiene precio',
      '',
      'No, no',
      "I don't chase what don't choose me",
      '',
      'Con amor se acabó',
      '',
      'Se acabó',
      '',
      'And',
      '',
      'I love me more',
      'Yo me elijo y se nota en mi piel',
      'Mi piel',
      'Mi cuerpo es templo aquí mando yo',
      'Solté sin drama caminé con flow',
      'Mi dignidad no tiene precio y punto',
      '¡Punto, no',
      "Él no es na', solo un show barato",
      'Barato',
      'Todo talk, no content pure fraud, ya',
      'Cuerpo loud alma mute, empty show',
      "Archivado ya, standard, pa' allá",
      'Click-click, screenshot',
      "Tick-tick, time's up",
      'Zip-zip lips shut',
      'Bye-bye, wise up',
      'Wise, wise wi-wi-wi-wi-wi-wise up',
      'What you got',
      '¡Ahora paga',
      'What you scared of',
      '',
      '¡Ahora paga',
      'Why you pressed',
      '',
      '¡Ahora paga',
      'What he gave',
      'Stress',
      'What she kept',
      'Blessed',
      'What he lost',
      'Best',
      'Say less',
      'Say less',
      'Gone',
      'Gone',
      'Gone',
      'Gone-gone-gone-gone',
      '',
      'I love me more',
      '',
      'Mi dignidad no tiene precio',
      '',
      'No, no',
      "I don't chase what don't choose me",
      '',
      'Con amor se acabó',
      '',
      'Se acabó',
      'And I love me more',
      'Gone, gone, gone, gone gone, gone, go-go-go-gone',
      "That's that",
      "That's that",
      'Gone gone, gone',
      '',
      "That's that",
      "That's that",
      'Go, gone, gone gone, gone',
      'Con amor',
      '',
      'Se acabó',
      '',
      'I love me more',
      '',
      'No tiene precio',
      'No',
      'No, no, no',
      '',
      'No tiene precio',
      'No',
      '',
      'No tiene precio',
    ],
  },
  {
    slug: 'la-pucelle-dorleans',
    title: 'La Pucelle D\'Orleans',
    year: 2026,
    tagline: 'Fire and faith.',
    order: 12,
    video: '/media/videos/la-pucelle-dorleans.mp4?v=captioned',
    videoFr: '/media/videos/la-pucelle-dorleans-fr.mp4?v=captioned',
    cover: '/media/covers/la-pucelle-dorleans.jpg?v=noheader1',
    audio: '/stream/la-pucelle-dorleans.mp3',
    audioAlt: '/stream/la-pucelle-dorleans.m4a',
    mp3Label: 'AIAS - La Pucelle D\'Orleans (320kbps).mp3',
    lyrics: [
      'Raise the banner',
      'Hold the line',
      'God before me',
      'The fire behind',
      'I come on the breath of angels',
      'I speak from the Source',
      'I come alone',
      'I rise as ten thousand',
      'I come empty-handed before',
      'You',
      'My life is in Your hands',
      'Do with it what You will',
      'I am Yours — I stand firm',
      'I do not blame the God of',
      'Heaven for the evil that men have done',
      'I do not lay the cruelty of the world at the feet of the Son of God',
      '',
      'Raise the banner',
      '',
      'Hold the line',
      '',
      'God before me',
      '',
      'The fire behind',
      '',
      'Raise the banner',
      '',
      'Hold the line',
      'Heaven owns my soul',
      'I am Yours',
      'I am Yours',
      'I, Joan of Orléans',
      'Oh',
      'Your love needs no proof',
      'No wound will make me leave',
      "Jesus, I'm all Yours",
      'My love for You outlasts every doubt',
      'Tell my enemies',
      'I do not tremble',
      'Death is only a shadow',
      'They can burn me to dust',
      'My soul will still stand',
      'Let them take my breath and my flesh',
      'Let them bind me to the stake',
      'My soul is sealed far beyond their reach',
      'My soul is above the fire',
      'I no longer cling to the breath',
      'I no longer cling to the clay',
      'I surrender everything I desire',
      'My future is in Your hands',
      'No more demands',
      'No more conditions',
      'Let me die of love for You',
      'Then call me back to life',
      'Chain my wrists in Rouen',
      'Crown my head with flames',
      'Call my courage madness',
      'Sell my breath to shame',
      'But the fire only reveals',
      'What God Himself has raised',
      'You burn the body beneath me',
      'But this light — you will never possess it',
      '',
      'Raise the banner',
      '',
      'Hold the line',
      '',
      'God before me',
      '',
      'The fire behind',
      '',
      'Raise the banner',
      '',
      'Hold the line',
      '',
      'Heaven owns my soul',
      '',
      'I am Yours',
      '',
      'Oh',
      'Oh',
      '',
      'I am Yours',
      '',
      'Oh',
      '',
      'I am Yours',
      '',
      'Oh',
      'The Kingdom of Heaven is calling our name',
    ],
    lyricsFr: [
      'Levez la bannière',
      'Tenez la ligne',
      'Dieu devant moi',
      'Le feu derrière',
      'Je viens dans le souffle',
      'des anges',
      'Je parle depuis la source',
      'Je viens seule',
      'Je me dresse comme dix mille',
      'Je viens les mains nues devant',
      'Toi. Ma vie est entre Tes mains',
      'Fais-en ce que Tu veux',
      'Je suis à Toi, je me tiens',
      'Je ne blâme pas le Dieu des',
      'Cieux pour le mal que',
      'les hommes ont fait',
      'Je ne mets pas la cruauté du',
      'monde aux pieds du Fils de Dieu',
      'Levez la bannière',
      'Tenez la ligne',
      'Dieu devant moi',
      'Le feu derrière',
      'Levez la bannière',
      'Tenez la ligne',
      'Le Ciel me possède',
      'Je suis à Toi',
      'Moi, la Pucelle d’Orléans',
      'Oh.',
      'Ton amour n’a pas besoin de',
      'preuves',
      'Aucune blessure ne me fera',
      'partir. Jésus, je suis à Toi',
      'Mon amour survit aux pourquoi',
      'Dites à mes ennemis',
      'je ne tremble pas',
      'La mort n’est qu’une ombre',
      'Ils peuvent me brûler',
      'en poussière',
      'Mon âme restera debout',
      'Qu’ils prennent mon souffle',
      'et ma chair',
      'Qu’ils me lient au bûcher',
      'Mon âme est scellée loin d’eux',
      'Mon âme est au-dessus du feu',
      'Je ne m’accroche plus',
      'au souffle',
      'Je ne m’accroche plus',
      'à l’argile',
      'J’abandonne tout ce que je veux',
      'Mon avenir est dans Tes mains',
      'Plus d’exigences',
      'Plus de conditions',
      'Laisse-moi mourir d’amour',
      'pour Toi',
      'Puis rappelle-moi à la vie',
      'Enchaînez mes poignets à Rouen',
      'Couronnez ma tête de flammes',
      'Traitez mon courage de folie',
      'Vendez mon souffle à la honte',
      'Mais le feu n’ouvre que',
      'Ce que Dieu a fait se lever',
      'Vous brûlez le corps sous moi',
      'Mais cette lumière,',
      'vous ne l’aurez pas',
      'Levez la bannière',
      'Tenez la ligne. Dieu devant moi',
      'Le feu derrière',
      'Levez la bannière',
      'Tenez la ligne',
      'Le Ciel me possède',
      'Je suis à Toi',
      'Oh. Oh.',
      'Je suis à Toi',
      'Oh.',
      'Je suis à Toi',
      'Oh.',
      'Le Royaume des Cieux',
      'appelle notre nom',
    ],
  },
  {
    slug: 'naar-w-dokhan',
    title: 'Naar w Dokhan',
    year: 2026,
    tagline: 'Fire and smoke.',
    order: 13,
    video: '/media/videos/naar-w-dokhan.mp4?v=captioned',
    cover: '/media/covers/naar-w-dokhan.jpg?v=noheader1',
    audio: '/stream/naar-w-dokhan.mp3',
    audioAlt: '/stream/naar-w-dokhan.m4a',
    mp3Label: 'AIAS - Naar w Dokhan (320kbps).mp3',
    lyrics: [
      "A face like an angel's light",
      'And beneath the gown, a devil',
      'You are neither human nor jinn',
      'But fire and smoke',
      'Her spit, molten honey molten — and in the depths, fire',
      'Your eyes, the gates of Hell — Hell and behind the lashes, jinn',
      'You were never a home',
      'You were never safety',
      'You were never love',
      'You were never tenderness',
      'You were fire',
      'You were smoke',
      'And I was no devil',
      'I came out human',
      'One body holding a thousand women',
      'And a madness where the colors war',
      'Yes',
      'Sweetness on the tip of the tongue — desire',
      'And beneath the fang, venom and a volcano',
      '',
      'Yes',
      'To love you and to loathe you, in one instant, the same',
      'Absolute hell, and delirium',
      '',
      'Yes',
      'You kill with a soft silence, and call it safety',
      'Safety',
      '',
      'You were never a home',
      'You were never safety',
      'You were never love',
      'You were never tenderness',
      'You were fire',
      'You were smoke',
      '',
      'And I was no devil',
      '',
      'I came out human',
      '',
      'Yes',
      'You slit the vein with the coldest spite',
      'And you walk in my funeral, tenderly',
      'You lit the fire with your own hand, then washed your hands of the smoke',
      "I left you — so before the world you claimed that I'm the devil",
      'You set your fire in my chest, your fire',
      'And housed the jinn within it',
      'I snatched your heart',
      "You're mine",
      'I made you tread live coals, alive',
      'And caged you in my hell, you human',
      'You lied',
      'You lied',
      'You lied',
      'I shattered your cursed mirrors with my own hand',
      'And freed my soul from the jailer',
      'By my own hand I saved my soul',
      'And I came out of your fire, human',
      '',
      'You were never a home',
      'You were never safety',
      'You were never love',
      'You were never tenderness',
      'You were fire',
      'You were smoke',
      '',
      'And I was no devil',
      '',
      'I came out human',
      'Never',
      '...a home',
      '',
      'Never',
      '...safety',
      'Never were you love',
      'Never',
      '...tenderness',
      '',
      'You were fire',
      'You were smoke',
      '',
      'And I was no devil',
      'But I came out human',
    ],
  },
  {
    slug: 'not-hard-to-love',
    title: 'Not Hard To Love',
    year: 2026,
    tagline: 'Easy to stay.',
    order: 14,
    video: '/media/videos/not-hard-to-love.mp4?v=captioned',
    cover: '/media/covers/not-hard-to-love.jpg?v=noheader1',
    audio: '/stream/not-hard-to-love.mp3',
    audioAlt: '/stream/not-hard-to-love.m4a',
    mp3Label: 'AIAS - Not Hard To Love (320kbps).mp3',
    lyrics: [
      'They tell you letting go feels like dying.',
      'They lied.',
      'It feels like waking up.',
      'And I finally woke up.',
      'I checked my phone like it was breathin\' for us,',
      'turned little crumbs into proof I could trust',
      'Bare minimum felt rich when I was starvin\',',
      'called it patience, but it was fear in a pretty dress',
      'I made a home in your maybes',
      'Kept lowerin\' the bar till my dignity',
      'had to crawl to reach it.',
      'Used to think love meant makin\' me small,',
      'beggin\' a man to whisper my name',
      'Then I met myself in the quiet today...',
      'She\'d been waitin\' all this time —',
      'found her spine, and she\'s done beggin\' now!',
      'I was not hard to love, I was lovin\' someone hard to reach!',
      '(Hard to reach!)',
      'I was not askin\' too much, I was askin\' the wrong man to see me!',
      '(To see me!)',
      'And I\'m not the wreckage,',
      'I\'m the woman who walked away whole! (Walked away whole!)',
      'No more crumbs! (No more crumbs!)',
      'No more knees! (No more knees!)',
      'No more beggin\' men to choose me!',
      'I got my name back! (Got my name back!)',
      'I got me!',
      'I thought lettin\' go was fallin\' — nah!',
      'That\'s the day I learned to stand!',
      'You lit a flame to burn me down —',
      'pray she finds the door faster than me!',
      'Caught my reflection — finally, an old friend,',
      'didn\'t look like your damage, looked like me again!',
      'Used to think love meant makin\' me small,',
      'beggin\' a man to whisper my name',
      'Then I met myself in the quiet today...',
      'She\'d been waitin\' all this time —',
      'found her spine, and she\'s done beggin\' now!',
      'I was not hard to love,',
      'I was lovin\' someone hard to reach!',
      '(Hard to reach!)',
      'I was not askin\' too much,',
      'I was askin\' the wrong man to see me!',
      '(To see me!)',
      'And I\'m not the wreckage,',
      'I\'m the woman who walked away whole! (Walked away whole!)',
      'I\'m not pretendin\' it didn\'t matter. I loved him.',
      'That part was real on my side.',
      'But the woman who loved him,',
      'she walked me home tonight.',
      'I was whole before him,',
      'and I\'m walkin\' out the same.',
      'My dignity came back quiet —',
      'didn\'t recognize her at first.',
      'She said, you kept lookin\' for shelter in',
      'the hands that made you shake.',
      'WAKE UP!',
      'I was not hard to love,',
      'I was lovin\' someone hard to reach!',
      '(Someone hard to reach!)',
      'I was not askin\' too much,',
      'I was askin\' the wrong man to see me!',
      '(Askin\' the wrong man!)',
      'And I\'m not the wreckage,',
      'I\'m the woman who walked away whole! (Walked away whole!)',
      'No more crumbs! (No more crumbs!)',
      'No more knees! (No more knees!)',
      'No more beggin\' men to choose me!',
      'I got my name back! (Got my name back!)',
      'I got me!',
      'No more crumbs.',
      'I\'m full.',
      'I got me.',
    ],
  },
  {
    slug: 'no-score',
    title: 'No Score',
    year: 2026,
    tagline: 'Nice meeting you.',
    order: 15,
    video: '/media/videos/no-score.mp4?v=captioned',
    cover: '/media/covers/no-score.jpg?v=20261001',
    audio: '/stream/no-score.mp3',
    audioAlt: '/stream/no-score.m4a',
    mp3Label: 'AIAS - No Score (320kbps).mp3',
    lyrics: [
      'Nice meeting you',
      '',
      'No, she said',
      'Nineteen forty-two on the rocks',
      'Seven in my pocket',
      'She tips her chin',
      'No, no, no',
      'No score',
      'No, no, no',
      '',
      'Nice meeting you',
      'Jaw set with a smile',
      'Took the L',
      'Hands near, not holding',
      'Took the L',
      'Staring at the ceiling',
      '',
      'Nice meeting you',
      'No, she said',
      'No score',
      'Staring at the ceiling',
      'No score',
      '',
      'Nice meeting you',
      'No, she said',
      '',
      'I stayed up staring at the ceiling',
      'Must have been the drinks',
      'Got to take the L sometimes',
      'Take the L',
      'I guess I do',
      'Took the L',
      'Whatever you got drink',
      'Staring at the ceiling',
      '',
      'Nice meeting you',
      'No, she said',
      'No score',
      'Staring at the ceiling',
      'No score',
      '',
      'How much of me would dissolve',
      'In a two-letter word',
      'She don\'t want no score',
      'Tied to her name',
      'She doesn\'t want any score tied to her name',
      'No score baby',
      'No score',
      'Tied to her name',
      '',
      'Nice meeting you',
      'Staring at the ceiling',
      'No score',
      'Nice meeting you',
      'No, she said',
      'No score',
      'Nice meeting you',
      'Took the L',
      'Whatever you got drink',
      'Staring at the ceiling',
    ],
  },
  {
    slug: 'one-chapter-too-soon',
    title: 'One Chapter Too Soon',
    year: 2026,
    tagline: 'Closed too early.',
    order: 15,
    video: '/media/videos/one-chapter-too-soon.mp4?v=captioned',
    cover: '/media/covers/one-chapter-too-soon.jpg?v=noheader1',
    audio: '/stream/one-chapter-too-soon.mp3',
    audioAlt: '/stream/one-chapter-too-soon.m4a',
    mp3Label: 'AIAS - One Chapter Too Soon (320kbps).mp3',
    lyrics: [
      'Tick-tock.',
      'Tick-tick-tick-tick.',
      'Tick-tock-tock-tock-tock-tock.',
      'Tick-tick-tick-tick. Tick.',
      'Tick-tock-tock-tock-tock.',
      'Tick-tock, tick-tock.',
      'Tick-tock.',
      'Qui vivra, verra.',
      'I only want you.',
      'Nobody else.',
      'Why can\'t we be right now?',
      'Why? Why?',
      'Why can\'t we?',
      'I want you right now.',
      'One chapter too soon. Tick-tock.',
      'My heart runs on a',
      'beat you chose.',
      'Tick-tock. Ta-ta-ta-tock.',
      'Tick-tick-tick-tock. Doom, doom,',
      'doom. Too soon,',
      'too soon.',
      'Soon soon,',
      'too soon, too soon.',
      'Ça passe ou ça casse.',
      'D-d-d-d-d-Digga, ich lieb\' sie.',
      'Das ist kein Spiel. Sie fragt warum,',
      'ich schweig\' und fühl\'.',
      'Zu früh, zu früh,',
      'ich kenn\' den Grund.',
      'Sag\'s nicht laut,',
      'ich halt\' den Mund.',
      'Wie spät ist es? Fünf Stunden,',
      'fünf Jahre.',
      'Tick-tock, tick-tock.',
      'Nur noch nicht jetzt.',
      'N-n-n-n-n-now.',
      'My mind plays tick-tock games.',
      'Is it love or just the wait?',
      'Circle around,',
      'keep circling back.',
      'Dance and wait.',
      'Presque, le mot le plus cruel.',
      'Presque jamais.',
      'Mieux vaut tard que',
      'presque jamais.',
      'C\'est la vie.',
      'À bientôt jamais.',
      'Dorénavant.',
      'Qu\'est-ce que j\'attends? Où,',
      'jusqu\'à quand?',
      'À la folie,',
      'je te choisis.',
      'Mais cette nuit,',
      'c\'est la folie. Tick-tock,',
      'mon cœur. Tick-tock. Too soon,',
      'too soon. Too soon.',
      'Too-too-too-too soon.',
      'One chapter too soon.',
      'Mm,',
      'Too-too-too-too-too-too soon.',
      'One chapter too soon.',
      'I want you right now.',
      'You keep saying wait.',
      'One chapter too soon. Mm,',
      'Too-too-too-too-too-too soon.',
      'One chapter too soon.',
      'Tick-tock-tock.',
      'Tick-tick-tick-tick-tock.',
      'Tick-tock-tock.',
      'Tick-tick-tick-tick-tick-tick-tock.',
      'My mind plays tick-tock games.',
      'Circle around.',
      'Dance and wait. Zu früh,',
      'zu-zu-zu früh.',
      'Zu früh, zu-zu-zu-zu früh.',
      'Oh là là.',
      'One chapter too soon.',
      'Too-too-too-too-too-too-too-too-too-too-too.',
      'Tick-tock. Tick-tock.',
    ],
  },
  {
    slug: 'rattler',
    title: 'Rattler',
    year: 2026,
    tagline: 'Don\'t step wrong.',
    order: 16,
    video: '/media/videos/rattler.mp4?v=captioned',
    cover: '/media/covers/rattler.jpg?v=noheader1',
    audio: '/stream/rattler.mp3',
    audioAlt: '/stream/rattler.m4a',
    mp3Label: 'AIAS - Rattler (320kbps).mp3',
    lyrics: [
      "Darlin'",
      "I knew somethin' was off right from the first bite",
      'Met you in Tyler under that rose-garden light',
      'You move like a serpent slow through the grass',
      'Your halo burned holy then burned out fast',
      'You hold love like a coiled snake in your hand',
      'Bless my soul',
      "I keep reachin' back for that",
      "You're the witch I keep callin' honey",
      "Been chasin' that burn since",
      'I learned what fire was',
      'Honey',
      'I know you love me to death',
      'Hand in hand to the grave on our very last breath',
      'Locked door',
      "'cause your kiss come with a coil",
      "Locked door you'll strike and leave me in the soil",
      "Locked door, I love you but I love breathin' more",
      "You threw my mama's glass cross against the wall",
      "Smelled like whiskey and another woman's shame",
      "I stood still as a sinner in the reverend's eye",
      "Not lookin' for sorry lookin' for a fight",
      'Glass in the carpet blood on the frame',
      'Smiled pretty for the neighbors like you smiled for the kill',
      'Even Bo runs low now tail tucked tight',
      "Ain't no wolf left in him since that spiteful night",
      'You curl up warm then you shed your skin',
      'I let you back once',
      "Won't let you back in",
      'No',
      '',
      'Honey',
      'I know you love me to death',
      'Hand in hand to the grave on our very last breath',
      '',
      'Locked door',
      "'cause your kiss come with a coil",
      "Locked door you'll strike and leave me in the soil",
      'Locked door',
      "I love you but I love breathin' more",
      'Giorgio on your neck strong enough to choke a man',
      "Smudged pink on a slow-burnin' Slim",
      "I'd rather drive to your place half-crazy with want than hear that keychain rattle and know you're huntin' me",
      "Porch light's on but it ain't a welcome home",
      "You're parked down the road in that Wrangler black as sin",
      'Carved your name in my Mustang broad daylight',
      'Walls got ears baby and the floor got a tongue',
      "Sittin' here with my whiskey and a fork",
      "Just me and that damn tickin' kitchen clock",
      "When you quit fussin' quit cussin' quit throwin' them plates",
      "Lord have mercy that's when I'm truly afraid",
      "'Cause the opposite of love ain't hate",
      "It's the quiet and that scares me worse than wakin' up to a coiled rattler right on your side of the bed",
      'Bought you that pink Ruger thirty years ago this fall',
      "Now I lay awake wonderin' if it's pointin' at me",
      'Rattle came first, baby',
      'Fair is fair',
      '',
      'Honey',
      'I know you love me to death',
      'Hand in hand to the grave on our very last breath',
      '',
      'Locked door',
      "'cause your kiss come with a coil",
      "Locked door you'll strike and leave me in the soil",
      'Locked door',
      "I love you but I love breathin' more",
      "Locked door, I burned the key don't live there no more",
      "Loved you like scripture but snakes don't think twice",
      'You had the only key',
      'I changed the locks',
      "Still love you, darlin' but I learned the cost",
      '',
      'I changed the locks',
      'I changed the locks',
      'Then I heard her voice',
      'Lust is a rattler dressed like a lover',
    ],
  },
  {
    slug: 'show-up',
    title: 'Show Up',
    year: 2026,
    tagline: 'Come over, I chose you.',
    order: 18,
    video: '/media/videos/show-up.mp4?v=captioned',
    cover: '/media/covers/show-up.jpg?v=20261001',
    audio: '/stream/show-up.mp3',
    audioAlt: '/stream/show-up.m4a',
    mp3Label: 'AIAS - Show Up (320kbps).mp3',
    lyrics: [
      'SHOW UP, BABY SHOW UP',
      'Baby SHOW UP, not the excuse, you in the ROOM',
      'Come OVER, I chose YOU',
      'Don\'t use me up and call it love',
      'Show up or don\'t, that\'s on YOU',
      'You chased MILES FOR THIS',
      'MILES FOR THIS',
      'Get your ass here right NOW',
      'YOUR ASS  here right NOW',
      'Forget the BOYS, you got your WOMAN here',
      'SHOW UP — SHOW UP',
      'Be HERE when I need you',
      'SHOW UP — SHOW UP',
      'Not just when they SEE you',
      'Stand on business or get on your KNEES',
      'If it ain\'t BRICKED, use your MOUTH',
      'Eat it like you MEAN it',
      'If I say NO, look at my FACE',
      'If I say NO, it\'s NO',
      'NO, NO BABY',
      'Stay, don\'t NUT and roll OFF',
      'NUT AND ROLL OFF',
      'It\'s done when I roll my EYES',
      'We both get OURS tonight',
      'I\'m making it rain',
      'I\'m making it rain',
      'REELS LOCK , I go off',
      'I just hit',
      'I lose it',
      'I shake',
      'the whole tray is dumping, babe',
      'DUMPING, babe',
      'Lay next to me, don\'t get scared',
      'Spin my EYES one more time',
      'Crack me again after the break',
      'I just hit, JUST HIT',
      'I lose it',
      'I shake, I SHAKE',
      'I lose it',
      'I shake, I SHAKE',
      'the whole tray is dumping, babe',
      'DUMPING, babe',
      'SHOW UP — SHOW UP',
      'Be HERE when I need you',
      'SHOW UP — SHOW UP',
      'Not just when they SEE you',
      'HERE BABY',
      'I BEAT that pussy up',
      'CLAPPED THEM CHEEKS',
      'YOUR WHOLE TRAY IS DUMPING BABY',
      'Crack me again after the break',
      'Crack me after the break',
      'SHOW UP, SHOW UP',
    ],
  },
  {
    slug: 'still-here',
    title: 'Still Here',
    year: 2026,
    tagline: 'I never left.',
    order: 17,
    video: '/media/videos/still-here.mp4?v=captioned',
    cover: '/media/covers/still-here.jpg?v=noheader1',
    audio: '/stream/still-here.mp3',
    audioAlt: '/stream/still-here.m4a',
    mp3Label: 'AIAS - Still Here (320kbps).mp3',
    lyrics: [
      'The cracks are where the gold is',
      'They told us we were broken',
      'They were wrong',
      'Oh',
      'They took the houses and the names',
      'They could not take the flame',
      'My mothers walked a thousand roads and carried it the same',
      'I come from women who kept walking when the whole world turned to smoke',
      'I found the stories left behind still burning in my throat',
      'When freedom finally came they thought it was a dream',
      'Free, with no home left to walk to but they still knew how to sing',
      'Look closer',
      'The cracks are where the gold is',
      'I am the temple built from the breaking',
      'These are my ruins',
      "I'm still standing",
      "I'm still singing",
      "I'm still here",
      "I'm still here",
      '',
      'Oh',
      'Hey',
      'They wrote us down as numbers',
      'We answered with our names',
      'They asked if the world still remembers',
      'I answer every time I sing',
      'Every scar is a witness',
      'Every name is a flame',
      "You don't have to forget to be free",
      'Free is saying our names out loud',
      'I carry them with me',
      '',
      'Look closer',
      'The cracks are where the gold is',
      'I am the temple built from the breaking',
      '',
      'These are my ruins',
      '',
      "I'm still standing",
      "I'm still singing",
      "I'm still here",
      'Some nights the dark still calls my name',
      'Some nights, it nearly wins',
      'But I remember how far they walked and the hope they carried then',
      'They broke us into pieces',
      'We kept the pieces holy',
      'I am not carrying ruin',
      'I am carrying them home',
      '',
      'Look closer',
      'The cracks are where the gold is',
      'I am the temple built from the breaking',
      '',
      'These are my ruins',
      '',
      "I'm still standing",
      "I'm still singing",
      "I'm still here",
      'We lived to sing it',
      'We still carry gold',
      'You are not the ruins',
      'You are the life that remains',
      '',
      'Oh',
    ],
  },
  {
    slug: 'the-one-i-came-home-to',
    title: 'The One I Came Home To',
    year: 2026,
    tagline: 'Every road ends here.',
    order: 18,
    video: '/media/videos/the-one-i-came-home-to.mp4?v=captioned',
    cover: '/media/covers/the-one-i-came-home-to.jpg?v=noheader1',
    audio: '/stream/the-one-i-came-home-to.mp3',
    audioAlt: '/stream/the-one-i-came-home-to.m4a',
    mp3Label: 'AIAS - The One I Came Home To (320kbps).mp3',
    lyrics: [
      'Zitto… zitto…',
      'Solo tu',
      'Yeah — yeah babe',
      'Some love just finds its way',
      'Some love was made to stay',
      "You're the one I came home to",
      "Two hours past midnight and it's still true",
      'Every road still leads to you',
      "You're the one I came home to",
      'Two twenty-four two forty-two',
      'Winter night felt like a',
      'Texas summer',
      'Beneath that oak tree under the stars',
      'Only the moon knew before I knew',
      'Anima mia',
      'You look at me like that',
      'I forget my own name',
      "Se l'inganno lascia l'amaro",
      'Sei il mio unico riparo',
      '',
      'Solo tu',
      "If you lose me that's on you",
      'Every lost road still ends in you',
      "You're the one I came home to",
      "Two hours past midnight and it's still true",
      'Every road still leads to you',
      "You're the one I came home to",
      'I choose you',
      'I choose you',
      'I choose you cuore mio',
      'I choose you',
      'Diecimila volti ma sei tu',
      'Sei irresistibile',
      'If this is a dream leave it on repeat',
      'Say my name slow',
      "I'm not going nowhere",
      'Home is a kingdom of two',
      '',
      "Se l'inganno lascia l'amaro",
      'Every lost road still ends in you',
      '',
      'Zitto… zitto…',
      'Tu — tu — solo tu',
      'Ancora',
      'Tu — tu — solo tu',
      'Per sempre con te',
      'Tu — tu — solo tu',
      'Tu — tu — solo tu',
      '',
      'Per sempre con te',
      'Tutte le strade portano a te',
      'Gira e rigira è sempre così',
      'I lost you for a while and never let go',
      'Amber and frost and I still choose you',
      "Ten thousand nights and I'd spend them all here",
      'Sei tu — sei tu sei tu',
      "You're the one I came home to",
      "Two hours past midnight and it's still true",
      'Ancora — ancora',
      'Every road still leads to you',
      'Tu — tu — solo tu',
      '',
      'Ancora — ancora',
      '',
      'Solo tu',
      "You're the one I came home to",
      '',
      'I choose you',
      'I choose you',
      'I choose you, cuore mio',
      'Ambra e brina',
      'And I still choose you',
      'Where you go',
      'I go',
      "I'm right here with you gioia mia",
      'Uniti per sempre',
      'The one I came home to',
      'Tu — tu — solo tu',
      '',
      'Solo tu',
    ],
  },
  {
    slug: 'the-only-one',
    title: 'The Only One',
    year: 2026,
    tagline: 'Only you.',
    order: 19,
    video: '/media/videos/the-only-one.mp4?v=captioned',
    cover: '/media/covers/the-only-one.jpg?v=noheader1',
    audio: '/stream/the-only-one.mp3',
    audioAlt: '/stream/the-only-one.m4a',
    mp3Label: 'AIAS - The Only One (320kbps).mp3',
    lyrics: [
      'Storm I Never Showed',
      'You made me the monster so you\'d have a story to sell!',
      'You\'re scrolling through our past like it\'s a dead man\'s feed.',
      'I could\'ve written a whole life, a whole light—',
      'but you just liked the bleed.',
      'I rose through the fire while you ran to what\'s hollow.',
      'Trading a masterpiece for a ghost you can follow.',
      'You\'re loyal to a shadow, building walls out of glass.',
      'While I\'m the real one watching your sanity pass.',
      'You sold a diamond just to buy back the dust.',
      'A hollow religion, a flicker of trust.',
      'You love it when I crumble, just a little, just enough.',
      'To feel that main-character magnetic touch.',
      'I know you flip, I know you switch the narrative.',
      'Making me the villain just to keep yourself the hero.',
      'You\'re paranoid I\'m lurking, checking status on your page.',
      'But you\'re the one who\'s locked inside your own digital cage.',
      'I see the fear sit heavy in your chest, no lie.',
      'That loop of old pain is where you go to die.',
      'I\'m the lifeguard God sent; you pushed me to sea.',
      'Telling everyone I\'m "unhinged," but that ain\'t me. Nah!',
      'You only read the title; you never touched the plot.',
      'You only read the title; you forgot the storm.',
      'You want the one who left; I\'m the one you forgot.',
      'Two storms in one room; they never settle well.',
      'But you feel me in your ribs when you\'re quiet in your hell.',
      'I\'m years ahead now, everything you said you need.',
      'But you\'re addicted to the garden where the weeds won\'t bleed.',
      'You told me, "Check the mirror," said I wasn\'t your type.',
      'Then you date the same ghost, just a different hype.',
      'It\'s not that you don\'t want this— you\'re just terrified of rain.',
      'You\'d rather stay parched than be cleansed by the pain.',
      'I\'m standing ten toes while your whole world falls.',
      'I grew into the giant you built walls against.',
      'Iron gets harder when it\'s kissed by the flame.',
      'I found my own soul when you blocked out my name.',
      'I know the soft under the armor, the attention you crave!',
      'You smile at my pain— that\'s the storm you never gave!',
      'That\'s the cloud in your lungs! That\'s the ghost in your grave!',
      'You made up your mind. I hear it.',
      'But remember...',
      'You only read the title.',
      'You never touched the plot.',
      'You never saw the storm...',
      'Because I was the only one',
      'who kept you dry.',
      'And now it\'s raining.',
      'I was the only one.',
    ],
  },
  {
    slug: 'the-sea-taught-me-my-name',
    title: 'The Sea Taught Me My Name',
    year: 2026,
    tagline: 'Named by the water.',
    order: 20,
    video: '/media/videos/the-sea-taught-me-my-name.mp4?v=captioned',
    cover: '/media/covers/the-sea-taught-me-my-name.jpg?v=noheader1',
    audio: '/stream/the-sea-taught-me-my-name.mp3',
    audioAlt: '/stream/the-sea-taught-me-my-name.m4a',
    mp3Label: 'AIAS - The Sea Taught Me My Name (320kbps).mp3',
    lyrics: [
      'Some things you learn on dry land',
      'Some things you only learn underwater',
      "I went to the deep where the shallow couldn't follow",
      'I gave all I had before',
      'I knew my own depth',
      'I called it love before',
      'I called myself home',
      'The water stripped me honest',
      "The water doesn't lie",
      "Deep water doesn't ask if you can swim",
      'It takes you under',
      'Gives you back to yourself',
      'I went under',
      'I came back mine',
      "Love didn't love me back still I loved it holy",
      'Unreciprocated love',
      'Still an act of love',
      'I gave my name to the deep',
      'Found an ocean underneath',
      'The sea taught me my name',
      'The sea taught me my name',
      'The sea taught me my name',
      'Salt heals what sugar covered up',
      'Salt remembers what fresh water forgets',
      'It taught me the way back home and home was always my name',
      'I learned to love without an answer',
      'I learned to live without asking why',
      'I learned to stay without a witness',
      '',
      'I went under',
      '',
      'I came back mine',
      'I threw my love into the sea',
      'It came back with my name',
      '',
      'Unreciprocated love',
      '',
      'Still an act of love',
      'The sea taught me my name',
      'The sea taught me my name',
      'Sweat tears and salt water',
      'I made a prayer of the deep',
      '',
      'Sweat tears and salt water',
      'I made a prayer of the deep',
      'I poured devotion into silence',
      'I stopped baptizing absence',
      'I stopped calling hunger love',
      "The sea took what wasn't mine gave me back what always was",
      'I ride the waves that pulled me under',
      "The tide answers to the moon but the moon can't move me",
      'Pan, Pan, Pan',
      "I'm going down",
      'Paan',
      'Paan',
      'Bring me back',
      '',
      'Paan',
      'Paan',
      'I did not drown',
      'I did not drown',
      '',
      'Unreciprocated love',
      '',
      'Still an act of love',
      'The sea taught me my name',
      'The sea taught me my name',
      'La mer, ma mère',
      'The water knew me before I did',
      'Je suis la fille de la mer',
      "Elle m'a rendu mon nom",
      'I am the daughter of the deep water',
      'The sea taught me my name',
      'Some things you only learn underwater',
      'Some things you only learn underwater',
    ],
  },
  {
    slug: 'wind-and-stone',
    title: 'Wind and Stone',
    year: 2026,
    tagline: 'One year of wind and stone.',
    order: 21,
    video: '/media/videos/wind-and-stone.mp4?v=captioned',
    cover: '/media/covers/wind-and-stone.jpg?v=noheader1',
    audio: '/stream/wind-and-stone.mp3',
    audioAlt: '/stream/wind-and-stone.m4a',
    mp3Label: 'AIAS - Wind and Stone (320kbps).mp3',
    lyrics: [
      'Tss-tss, tit',
      'Tis-tis, tss',
      'Tss-tss, tit',
      'Tis-tis, tss',
      'Round and round, round, round',
      "The walls are breathing the cold's alive",
      "I don't know my name, my name my name",
      "I don't know the time the time, the time",
      'Wind and stone, stone stone',
      "Numb to the bone the sky's melting slow",
      "I've forgotten their eyes their eyes",
      'The fire speaks in tongues',
      "I can't understand",
      "There's blood in the snow warm in my hand my hand",
      '',
      'Tss-tss, tit',
      '',
      'Tis-tis, tss',
      'Wind and stone hear my lonely cry',
      'I am the last one the last one',
      'My heart still pounds like thunder underground',
      "I'm not ready to die",
      'Round and round round and round, and round and round, round, and round and round',
      'And round and round',
      'I talk to the dead and the dead talk back',
      'Their faces are melting the walls turning black',
      'I paint my hand on the stone',
      'I leave my name so the ones who come after will know that I came',
      'I came',
      "Ten thousand eyes and they're all mine",
      "The dead are laughing the sky's on fire",
      'Faster faster, the ground comes loose',
      'The stone is breathing and',
      "I'm falling through",
      'Tss-tss-tss-tss-tss',
      'Am I dreaming',
      'God, am I dreaming',
      'Do you hear me calling',
      'God, do you hear me',
      'Someone hold me',
      'Someone hold me',
      "I'm falling down, falling down, falling down, falling down",
      'Down, down, down, down, down',
      "I'm falling down falling, falling, falling",
      'Deep, deep, down',
      'Wind and stone feel my hand on your face',
      'I am not the last, not the last',
      'The flame still breathes hope calls my name my name',
      "Round and round but I'm not the same not the same",
      'Wind and stone, stone, stone',
      'One year of wind and stone',
      '',
      'Tss-tss, tit',
      '',
      'Tis-tis, tss',
      'Tss',
      'Tss',
      'Tss',
    ],
  },
  {
    slug: 'never-told-you-why',
    title: 'Never Told You Why',
    year: 2026,
    tagline: 'I never told you why.',
    order: 1,
    video: '/media/videos/never-told-you-why.mp4?v=captioned',
    cover: '/media/covers/never-told-you-why.jpg?v=20261016',
    audio: '/stream/never-told-you-why.mp3',
    audioAlt: '/stream/never-told-you-why.m4a',
    mp3Label: 'AIAS - Never Told You Why (320kbps).mp3',
    lyrics: [
      'I wait until the whole house sleeps',
      'Six of them, and none of them know',
      'The oil candle, back to the wall',
      'I read the first two words you wrote',
      'You still send one every two weeks',
      'And I stopped writing back to you',
      'The one you finally said',
      'You wrote it down, you burned it',
      'I still go to his room',
      'Where the light go dark',
      '',
      'I never told you why',
      'I cannot write you back',
      'You went and got married',
      'And I never told you',
      'You deserve the reason',
      '',
      'My finger got the burn you left',
      'I made a fist and kept it shut',
      'The dust came off it on my hand',
      'I let the wind take what remains',
      '',
      'I never told you why',
      'I cannot write you back',
      'You went and got married',
      'And I never told you',
      'You deserve the reason',
      '',
      'I don\'t owe my guilt to anyone',
      'They call me wise and I am not',
      'They still come here asking me for help',
      'I already hurt the only one',
      '',
      'I never told you why',
      'I cannot write you back',
      'You went and got married',
      'And I never told you',
      'You deserve the reason',
      '',
      'My finger got the burn',
      'I made a fist around it',
      'And I let the wind take what remains',
      'I hold my lip now',
      'And let it go',
    ],
  },
  {
    slug: 'you-the-one',
    title: 'You The One',
    year: 2026,
    tagline: 'We met under God.',
    order: 1,
    video: '/media/videos/you-the-one.mp4?v=captioned',
    cover: '/media/covers/you-the-one.jpg?v=20261016',
    audio: '/stream/you-the-one.mp3',
    audioAlt: '/stream/you-the-one.m4a',
    mp3Label: 'AIAS - You The One (320kbps).mp3',
    lyrics: [
      'I still hear you',
      'when the room go quiet',
      'I was backing up fast',
      'Calling your name',
      'You smiled and kept walking',
      'Hit my chest',
      'Sat on the curb',
      'Wiped my face',
      'I said I love you',
      'I said why',
      'I said babe, why you don\'t talk to me',
      'I can still hear it',
      'When it got heavy',
      'I ain\'t fold',
      'I still know',
      '',
      'You the one',
      'We met under God',
      'I told your mother',
      'You can\'t help me',
      'Let love only come once',
      'No one but you changed me',
      'You the one',
      'You say my name three times',
      'When love got tested',
      'we ain\'t broke',
      'I can never forget you',
      '',
      'You were in my arms',
      'and I didn\'t kiss you more',
      'I didn\'t lose me',
      'I lost who I was',
      'You give me peace',
      'when nothin\' feels sure',
      'I can\'t leave in peace',
      '\'cause you the one',
      'I give you my all',
      'This love keep growin\'',
      'Come with me',
      'Come with me',
      '',
      'I give you my all',
      'if I keep holdin\' in',
      'Come with me',
      'We met under God',
      'I told your mother',
      'You can help me',
      'That love only come once',
      'No one but you will change me',
      'You the one',
      'You say my name three times',
      'When love got tested',
      'we ain\'t broke',
      'I can never forget you',
      '',
      'I can still hear it',
      'I was backing up fast',
      'You kept walking',
      'I can still hear it',
    ],
  },
  {
    slug: 'you-wasnt',
    title: 'You Wasn\'t',
    year: 2026,
    tagline: 'You wasn\'t who I thought.',
    order: 22,
    video: '/media/videos/you-wasnt.mp4?v=captioned',
    cover: '/media/covers/you-wasnt.jpg?v=noheader1',
    audio: '/stream/you-wasnt.mp3',
    audioAlt: '/stream/you-wasnt.m4a',
    mp3Label: 'AIAS - You Wasn\'t (320kbps).mp3',
    lyrics: [
      'You said stay gone',
      'Then stay close',
      'I let the fire die',
      'You came back like smoke',
      "Thought you was You wasn't",
      "Thought you was You wasn't",
      'I was blind You loved it',
      "Thought you was different You wasn't",
      'Thought you was done You was waiting',
      'Thought you was solid You was shaking',
      'Thought you was safe You was the fire',
      'Thought you was sorry You was rehearsing',
      'Thought you was the one You was practice',
      'Thought you was worth it I was worth more',
      'Only thing I miss',
      "Is the man I was before You wasn't",
      "You wasn't No, you wasn't different",
      "You wasn't You wasn't",
      'You was just the same damn flame',
      '',
      "You wasn't You wasn't",
      'I was worth more',
      "You said we're done But you never let go",
      'Kept me on standby Like I was still yours',
      'You showed me the cracks I moved right in',
      'You was a house on fire I called it coming home',
      'You kept the door half-open',
      'Then blamed me when I came through New face by noon',
      'Same flame, new blame',
      'You lit the match',
      'I said sorry for the burn',
      'You said no one could love you',
      'The way that I did',
      'And the cruelest part of leaving Is I know that part was true',
      'Got fluent in your panic',
      'Held my breath around you Till I forgot to breathe',
      "I wasn't losing it I was close",
      "I wasn't the fire I was the smoke",
      "I don't miss you I miss who I was",
      'I made us a home And forgot how to leave',
      'Thought you was different',
      'No, I was different',
      'Thought you was done You was waiting',
      'Thought you was solid You was shaking',
      'Thought you was safe You was the fire',
      "Thought you was sorry Now I'm gone",
      'Thought you was the one You was practice',
      'Thought you was worth it I was worth more',
      'Only thing I saved',
      'Is the man I was before',
      '',
      "You wasn't You wasn't",
      "No, you wasn't different",
      '',
      "You wasn't You wasn't",
      'You was just the same damn flame',
      'The sick part is',
      "I don't miss you",
      'I miss who I was',
      'Before I thought you was',
      'Anything at all',
      "You wasn't",
    ],
  },
  {
    slug: 'flip-the-sky-upside-down',
    title: 'Flip The Sky Upside Down',
    year: 2026,
    tagline: 'You said leave. I left.',
    order: 1,
    video: '/media/videos/flip-the-sky-upside-down.mp4?v=captioned',
    cover: '/media/covers/flip-the-sky-upside-down.jpg?v=20261018',
    audio: '/stream/flip-the-sky-upside-down.mp3',
    audioAlt: '/stream/flip-the-sky-upside-down.m4a',
    mp3Label: 'AIAS - Flip The Sky Upside Down (320kbps).mp3',
    lyrics: [
      'I close my mouth',
      'Get in the car',
      'Throw it in drive',
      'I cut the ground under my feet',
      'And flip the sky upside down',
      'Came to you in pieces',
      'My mouth between my heart',
      'I lied through my teeth',
      'And bit the lips beneath',
      'I knocked once and stopped',
      'I walk out from the porch',
      'Back alone in the car',
      'Windows shut',
      'I sat outside',
      'You said leave',
      'I left',
      'I closed my mouth',
      'Get in the car',
      'Before we didn\'t drive',
      'Hands sweating',
      'Face red',
      'Hands shaking',
      'I sank in my seat',
      'I sank in my seat',
      'I drink from the glass',
      'And chew on it',
      'I set my only fire',
      'Then turned around and blew on it to put',
      'the fire out',
      'I sat under the rain',
      'I hid my face fast',
      'Shot myself in the foot',
      'Turned my chin down and looked away',
      'I walk out from the porch',
      'Back alone in the car',
      'Windows shut',
      'I sat outside',
      'You said leave',
      'I left',
      'I closed my mouth',
      'Get in the car',
      'Throw it in drive',
      'Hands sweating',
      'Face red',
      'Hands shaking',
      'I sank in my seat',
      'Hands locked on the wheel',
      'I counted my breaths',
      'I gripped the wheel tight',
      'Hit my head with my fist',
      'Broke down in my seat',
      'I stared at myself in the mirror',
      'I shook my head',
      'I rolled my lips back',
      'I closed my mouth',
      'Get in the car',
      'Throw it in drive',
      'Hands sweating',
      'Face red',
      'Body shaking',
      'I sank in my seat',
      'I left',
      'A sink in my sea',
    ],
  },
  {
    slug: 'go-away-take-ii',
    title: 'Go Away (Take II)',
    year: 2026,
    tagline: 'Bass said go. Paris said go louder.',
    order: 1,
    video: '/media/videos/go-away-take-ii.mp4?v=captioned-20261027',
    cover: '/media/covers/go-away-take-ii.jpg?v=20261018',
    audio: '/stream/go-away-take-ii.mp3',
    audioAlt: '/stream/go-away-take-ii.m4a',
    mp3Label: 'AIAS - Go Away (Take II) (320kbps).mp3',
    lyrics: [
      'You don\'t even know what I do to stay in control.',
      'Keep my name out your mouth.',
      'I got eyes everywhere, I listen in,',
      'Hear who said what \'bout me, names get filed.',
      'They know my whip, so I move low-key,',
      'Pull up with somebody else, keep it off me.',
      'I know your moves, I know your world,',
      'Stay connected — you don\'t even know.',
      'I used to pray you\'d stop caring.',
      'Now I got you blocked on everything…',
      'Still catch you watchin\' when I\'m out.',
      'You were soft. Grateful. Too forgettable.',
      'I wanted some shyt that could spin the block on me, leave me fiendin\'.',
      'Sweet talk and rented swagger don\'t hit the same.',
      'I need the kind of love that moves before it heals.',
      'And me checkin\' your pin like I lost my mind.',
      'He did that.',
      'Then crawled right back to that same tired bitch',
      'And left my chest on read… like I was nothing.',
      'My nerves fried, I can\'t take all this!',
      'Phone blowin\' up, but the vibe ain\'t worth the fit!',
      'Phone on DND, charge a gun, brain still racin\'!',
      'Every damn year I tell myself I don\'t give a…',
      'Leave me!',
      'Move on!',
      'Go away!',
      'Are you still stuck on my ass?!',
      'Get off my back!',
      'Don\'t call me.',
      'Don\'t pull up.',
      'Don\'t wait.',
      'Truth is I do love you…',
      'Je t\'aime vraiment…',
      'Mais va-t\'en…',
      'But I need you gone.',
      'Go away.',
      'Go away.',
      'I keep receipts on everybody, my phone a graveyard of the same old thirst.',
      'My people, my ghosts — they never fail me.',
      'I got them all, but I want none.',
      'Can\'t hand nobody the crown.',
      'I\'m the spark, the lock, and the whole damn fame.',
      'I can have your whole body switch tempo off one look.',
      'I\'m with a rebound shyt right now,',
      'Knew it was dead from jump.',
      'I be clockin\' exits before I even sit down.',
      'You handed me your soul.',
      'I handed you a script.',
      'Truth is I burned you just to save myself.',
      'Fakin\' for the timeline way easier than tellin\' the truth.',
      'I post, I film, I chase the views.',
      'Get off my page!',
      'I don\'t know why I tell people so much.',
      'I don\'t know why I cry when I talk about my life.',
      'Pas toi.',
      'Jamais toi.',
      'They left,',
      'And I turned \'em into a ghost.',
      'Now I\'m the one being haunted.',
      'I\'m not askin\'. I\'m tellin\' you what it is.',
      'Every time it gets too real,',
      'I fuck out and wreck it myself.',
      'Soon as they settle in, I get gone.',
      'Soon as somebody loves me bright,',
      'I ghost first and call it fate.',
      'Lâche-moi !',
      'Trace ta route !',
      'Casse-toi !',
      'C\'est c\'que j\'beugle quand ça devient trop réel !',
      'En vrai j\'te kiffe de ouf…',
      'J\'t\'aime en vrai… mais va-t\'en…',
      'Mais j\'peux pas t\'laisser re-débarquer dans ma zone.',
      'J\'tourne en rond, j\'fais le vide, j\'efface ton blase.',
      'C\'est mort, c\'est dead, j\'ai coupé les ponts.',
      'Lâche-moi !',
      'Passe à autre chose !',
      'Va-t\'en !',
      'C\'est c\'que j\'hurle quand ça devient trop réel !',
      'La vérité, c\'est qu\'ouais, j\'t\'aime…',
      'J\'t\'aime en vrai… mais va-t\'en…',
      'Mais j\'peux pas t\'laisser rester là, près d\'moi.',
      'Va-t\'en.',
      'J\'sais qu\'y a un truc qui tourne pas rond chez moi.',
      'En vrai, j\'le savais dès l\'départ.',
      'C\'est moi le point commun dans toutes ces histoires.',
      'À chaque fois.',
      'Je l\'sais.',
      'J\'sais juste pas encore',
      'Quoi faire de tout ça…',
      'Moi en train d\'supplier l\'univers…',
      'Tu t\'rends compte ?',
      'J\'suis à bout…',
      'J\'sais exactement comment arrêter.',
      'J\'ai juste pas envie.',
    ],
  },
  {
    slug: 'dear-him',
    title: 'Dear Him',
    year: 2026,
    tagline: 'I\'m writing this letter I\'ll never send.',
    order: 1,
    video: '/media/videos/dear-him.mp4?v=captioned',
    cover: '/media/covers/dear-him.jpg?v=20261018b',
    audio: '/stream/dear-him.mp3',
    audioAlt: '/stream/dear-him.m4a',
    mp3Label: 'AIAS - Dear Him (320kbps).mp3',
    lyrics: [
      'There he go.',
      'I already know what it says.',
      'Always the same thing.',
      'Long paragraph.',
      'His feelings. Like I asked.',
      'Baby, I read it. Laughed.',
      'Was thinking about Whataburger.',
      'Spicy chicken sandwich, extra pickles,',
      'Before I even put the phone down.',
      'That\'s not cold.',
      'That\'s just, I\'m not the one.',
      'Somebody shows me their pain',
      'And something in me just clocks out.',
      'The second a man shows me he needs me,',
      'I\'m done.',
      '',
      'I dropped my Camaro with the music on blast',
      'So my head don\'t start talking back.',
      'You said I\'m lazy, spending my days on my phone,',
      'Unbothered, that\'s my way.',
      'What if you were right about some things?',
      'What if I\'m just scared of being still?',
      'I don\'t ask nobody for nothing, that\'s how I\'m built.',
      'Needing someone means they can leave.',
      'I can\'t live with that guilt.',
      'God has got my back, even when the path ain\'t clear.',
      'I ain\'t gotta leave to fly.',
      'Can\'t break my lease, so I just drive.',
      '',
      'Fresh cut every Friday.',
      'New me, new fight.',
      'Three-day weekend on the plane,',
      'My favorite peace of mind.',
      'You out here talking stability.',
      'I don\'t entertain.',
      'I need to feel something moving,',
      'Not something that stays the same.',
      'Catch me at the mall,',
      'Bagging dresses, I love the eyes on me.',
      'Alone in the air, I\'m warmer for the second hand.',
      'Shots of Rumple Minze, peppermint remedy.',
      'Love the chase, the rush, the burn, the tension.',
      'That feeling of being wanted,',
      'That\'s my only intention.',
      'London with you was dry, and I mean everything.',
      'Couldn\'t even make me wet.',
      'Met you at your worst, no fire, no spark.',
      'Now you\'re a ten. Funny how that works in the dark.',
      'I made you. I changed you.',
      'I hurt you.',
      'That hurt taught you everything.',
      'I liked you better when you needed me,',
      'Before you learned how to leave.',
      'Everybody\'s thirsty for me.',
      'You were different. Still ran.',
      'You loved me too much. That was the turn-on.',
      'Being somebody\'s everything.',
      'That\'s a shutdown.',
      '',
      'I wish someone would push me.',
      'I wish someone believed in what I could be.',
      'But when they do, I run.',
      'I keep one hand on every door',
      'Before I\'ve even walked through it.',
      'That\'s not protection. That\'s just Tuesday.',
      'I know something\'s off in me.',
      'I know. I know I\'m the reason.',
      'I\'m scared of going nowhere.',
      'Knowing never stopped me.',
      'I love you. I don\'t want you.',
      'Both of those are true, and I hate myself for it.',
      'I\'m good at leaving.',
      'It\'s the staying that breaks me.',
      '',
      'Dear you.',
      'I\'m writing this letter I\'ll never send.',
      'You poured your love out. I watched it drain.',
      'Search it on TikTok, call it a win.',
      'You loved me harder than anyone.',
      'I love that you love me.',
      'That\'s the sick part.',
      'I keep the light off so neither of us has to see.',
      'I keep you locked in the dark.',
      'Love me in the dark.',
      '',
      'Saturday at the club, you kissing her.',
      'Chest went tight. I ignored it.',
      'You reached for my hand. I pulled back.',
      'Next time, maybe. Probably not.',
      'I saw the hurt in your eyes,',
      'The love underneath.',
      'And something turned me on. Imagine that.',
      'Even my homeboy said,',
      'That ain\'t the guy you described.',
      'Nobody here even heard your name.',
      'I made you the bad guy',
      'So I don\'t have to look at me.',
      'I\'m so tired of writing everyone\'s story',
      'And having nothing for my own.',
      '',
      'Tu m\'as montré une tempête que je n\'avais jamais vue.',
      'Et je suis devenu accro à la pluie.',
      'Même maintenant, si tu appelles, je réponds.',
      'Je t\'aimais bien.',
      'Je sais.',
    ],
  },
  {
    slug: 'sunday-clothes',
    title: 'Sunday Clothes',
    year: 2026,
    tagline: 'You wear your mercy like your Sunday clothes.',
    order: 1,
    video: '/media/videos/sunday-clothes.mp4?v=captioned',
    cover: '/media/covers/sunday-clothes.jpg?v=20261018b',
    audio: '/stream/sunday-clothes.mp3',
    audioAlt: '/stream/sunday-clothes.m4a',
    mp3Label: 'AIAS - Sunday Clothes (320kbps).mp3',
    lyrics: [
      'You said, “I’m gonna pray for you.”',
      'Like God was somewhere else.',
      'You look like heaven in the neon glow,',
      'But heaven keeps a trapdoor down below.',
      'You walk in like the room was built around your face,',
      'Smoke on your jacket, city glitter in your wake.',
      'You touched my leg like a secret',
      'while the traffic turned to gold,',
      'Said, “This is how I show it,”',
      'and I hated how I hoped.',
      'and you told me things so heavy',
      'they were shaking in your teeth,',
      'Old wounds, family ghosts,',
      'the kind that never leave.',
      'And I held them like a candle,',
      'like a promise, like the truth.',
      'You kissed me like a future.',
      'Now I know that’s what you do.',
      'You keep your heart in locked rooms,',
      'You keep your truth half-said.',
      'Want me reading all your silence,',
      'Then punish me for what I read.',
      'You love me safest at a distance,',
      'Close enough to be adored.',
      'Every room you build has trapdoors.',
      'Every “stay” becomes a door.',
      'You said, “I’m gonna pray for',
      'you,” Like prayer could wash your hands of me.',
      'You wear your mercy like your Sunday clothes,',
      'But God still sees what you did to me. You love the ones who leave,',
      'Use the ones who stay.',
      'Call it love, but every kiss you gave',
      'Was just another way to leave.',
      'Some hearts look holy till they bruise.',
      'You wear your mercy like your Sunday clothes,',
      'But God still sees right through.',
      'You gave me one of those nights',
      'that ruins every night',
      'after, Red velvet, dim light, your mouth',
      'tasting of smoke and laughter.',
      'Midnight in a city made',
      'to make a stranger feel like fate,',
      'The kind of tenderness that comes too late',
      'and leaves too late.',
      'You loved my mind in daylight,',
      'Loved the way I made things wide,',
      'Loved the calm, the plans,',
      'the language, Just not with your whole body’s fire.',
      'So I became your safe place,',
      'Never quite your choice,',
      'The hands that held the storm for you,',
      'Not the name you’d say out loud.',
      'You want devotion with no witness,',
      'Warmth without the heat.',
      'Want a heart to break around you',
      'Then still fall at your feet.',
      'You call your guilt “being overwhelmed,”',
      'Your cruelty “needing space.”',
      'You throw a halo on the damage',
      'And call your leaving grace.',
      'You said, “I’m gonna pray for you,”',
      'Like prayer could wash your hands of me.',
      'You wear your mercy like your Sunday clothes,',
      'But God still sees what you did to me.',
      'You love the ones who leave,',
      'Use the ones who stay.',
      'Call it love, but every kiss you gave',
      'Was just another way to leave.',
      'Some hearts look holy. Till they bruise.',
      'You wear your mercy like your Sunday clothes,',
      'But God still sees right through',
      'right through. Your pretty little rescue,',
      'Right through. The boy behind the perfume,',
      'Right through. That “I hate being mean to you.”',
      'God still sees right through. I',
      'would’ve burned my whole life down',
      'Just to keep your night from going dark.',
      'That’s the part that still destroys me.',
      'That’s the part I can\'t outrun.',
      'There was a night you held me like',
      'Like you had nowhere else to go',
      'You always meant it in the moment.',
      'That’s what makes the ending hurt.',
      'You gave me proof you cared',
      'Before you gave me none of you.',
      'That’s why the silence felt so violent.',
      'That’s why I still taste the truth.',
      'You said, “I’m gonna pray for you,”',
      'Like prayer could wash your hands of me.',
      'You wear your mercy like your Sunday clothes,',
      'But God still sees what you did to me.',
      'You need the ones who worship,',
      'Punish the ones who stay.',
      'Need a heart to break beside you',
      'So yours can look okay.',
      'Some hearts look holy Till they bruise.',
      'You wear your mercy like your Sunday clothes,',
      'But God',
      'still sees right through.',
      'So go on, baby, bless me.',
      'Turn my tears into your proof.',
      'Everybody looks innocent',
      'In soft light and expensive rooms.',
      'You wear your mercy like your Sunday clothes.',
      'I wore your name like a bruise.',
      'Nothing looks more dangerous',
      'Than a beautiful excuse.',
    ],
  },
  {
    slug: 'fuego-del-mundo',
    title: 'Fuego Del Mundo',
    year: 2026,
    tagline: 'For the World Cup. We stand as one.',
    order: 1,
    video: '/media/videos/fuego-del-mundo.mp4?v=captioned',
    cover: '/media/covers/fuego-del-mundo.jpg?v=20261018',
    audio: '/stream/fuego-del-mundo.mp3',
    audioAlt: '/stream/fuego-del-mundo.m4a',
    mp3Label: 'AIAS - Fuego Del Mundo (320kbps).mp3',
    lyrics: [
      'Oh, oh, oh',
      'Fuego del mundo',
      'Oh, oh, oh',
      'Everybody rise',
      'Oh, oh, oh',
      'Stand up, stand up',
      'From the fire we rise',
      'Oh, oh, oh',
      'Yeah',
      'Look how far we\'ve come',
      'Feel the flame',
      'Every flag, every heart',
      'Every city ablaze',
      'Hearts beating with you',
      'Rhythm in the air',
      'This is our night',
      'The world is here',
      'Can you feel it burning',
      'In your chest',
      'Heat is rising',
      'No time to rest',
      'Everybody change',
      'Everybody sing',
      'No se apaga este fuego',
      'Todos de pie',
      'Gloria nos espera',
      'Entramos en la historia',
      'Now or never',
      'The moment is here',
      'Fuego, fuego',
      'Fuego, el mundo de pie',
      'Vale, vamos',
      'Let\'s go',
      'Ay, oh, fuego',
      'Allez',
      'Let\'s go',
      'Ay, oh, fuego',
      'Dale duro, dale más',
      'Si caímos, nos levantamos',
      'De barrio a continente',
      'Hoy vinimos a ganar',
      'Tous ensemble, on brûle',
      'Le monde est à nous',
      'On l\'allume',
      'La flamme ne s\'éteint jamais',
      'Debout, debout, on va tout cramer',
      'Fuego, fuego',
      'El mundo de pie',
      'Unidos, unidos',
      'Todos nosotros unidos',
      'Son sueños, una voz',
      'One night, one flame',
      'Somos uno',
      'La dignidad y el orgullo',
      'Son nuestros',
      'Fuego del mundo',
      'Ardiendo juntos',
      'Un mundo unido',
      'Invencible',
      'Fuego, fuego',
      'Fuego',
      'El mundo de pie',
      'The stars are shining',
      'The world is watching you',
      'Ardiendo',
      'Ardiendo',
      'Ay, oh',
      'Let\'s go',
      'Ay, oh, fuego',
      'Mil banderas',
      'Un cielo',
      'Que tiemble el suelo',
      'La copa en el pecho',
      'Que ruede otra vez',
      'Vale, vamos',
      'Ay, oh, fuego',
      'Fuego del mundo',
      'We stand as one',
    ],
  },
  {
    slug: 'noir-sur-noir',
    title: 'Noir Sur Noir',
    year: 2026,
    tagline: 'Don\'t say a word.',
    order: 1,
    video: '/media/videos/noir-sur-noir.mp4?v=captioned',
    cover: '/media/covers/noir-sur-noir.jpg?v=20261026',
    audio: '/stream/noir-sur-noir.mp3',
    audioAlt: '/stream/noir-sur-noir.m4a',
    mp3Label: 'AIAS - Noir Sur Noir (320kbps).mp3',
    lyrics: [
      'Get that camera out my face',
      'Stop chasing me, I ain\'t no show',
      'I told you no paparazzi here',
      'Don\'t say a word',
      'Tints low, shades on',
      'Hands on my thighs',
      'Lips on my neck',
      'If I ain\'t sleepin',
      'If I ain\'t sleepin, you ain\'t sleepin',
      'We sleep when we\'re dead',
      'Grip that shit, don\'t say a word',
      'Chill right here, don\'t say nothin\'',
      'Phone face down, on DND',
      'We\'re here, and they\'re there',
      'We here, they over there',
      'You sent me a letter, I sent you a crown',
      'Sheets already back',
      'Pillow under my head',
      'Your hand right between my legs',
      'Don\'t say a word',
      'Tints low, shades on',
      'Hands on my thighs',
      'Lips on my neck',
      'Grip that shit',
      'Don\'t say a word',
      'Keys, wallet, phone, all on me',
      'Bendin\' corners, no hands on the wheel',
      'You mine, I ain\'t done with ya',
      'Tints low, shades on',
      'I want that again',
      'Noir sur noir, on glisse dans l\'ombre',
      'Dix puissance neuf, on multiplie le nombre',
      'Un plus un, c\'est nous, ma chérie, reste focus',
      'Saint-Tropez, Tokyo, les paparazzis nous coursent',
      'Ils nous appellent les Carter, on répond même pas',
      'Un plus un, toi et moi, toujours un, on lâche pas',
      'J\'dors pas, tu dormiras pas',
      'J\'ai arrêté d\'penser, c\'est la tienne aussi',
      'On reste là, personne nous touche',
      'Tints low, shades on, personne nous voit',
      'It\'s you and me now',
      'Hands on my thighs',
      'Lips on my neck',
      'Don\'t stop, keep it doin',
      'Don\'t say a word',
      'Don\'t, don\'t, don\'t, don\'t say a word',
      'Don\'t, don\'t, don\'t say a word',
      'Tints low, tints low, shades on',
      'Hands on my thighs',
      'Lips on my neck',
      'Grip that shit',
      'Don\'t say a word',
      'Get that camera out my face',
    ],
  },
  {
    slug: 'god-sees-me',
    title: 'God Sees Me',
    year: 2026,
    tagline: 'God sees the break.',
    order: 1,
    video: '/media/videos/god-sees-me.mp4?v=captioned',
    cover: '/media/covers/god-sees-me.jpg?v=20261029',
    audio: '/stream/god-sees-me.mp3',
    audioAlt: '/stream/god-sees-me.m4a',
    mp3Label: 'AIAS - God Sees Me (320kbps).mp3',
    lyrics: [
      'Pain is already mine',
      'I hold the pain',
      'Heat is already here',
      'I look at the fear',
      'I stay',
      'I smelled heaven in a dream',
      'I do not blame You',
      'Under the water',
      'If it takes me',
      'So be it',
      'Seeds have to break',
      'We have to break',
      'We have to break',
      'Love while we break',
      'Love while I break',
      'Love while we break',
      'Love while I break',
      'Every day',
      'Fear cost me',
      'I lost myself',
      'Fear cost me',
      'I lost myself',
      'Alone was the door',
      'You stayed when no one did',
      'I keep the smile',
      'The hurt stays',
      'Seeds have to break',
      'We have to break',
      'Seeds have to break',
      'We have to break',
      'Love while we break',
      'Love while I break',
      'Love while we break',
      'Love while I break',
      'Every day',
      'The Cross is the key',
      'If he does not turn to love',
      'He dies',
      'Some refuse the love',
      'They die',
      'Love or die',
      'I rise after the break',
      'Seeds have to break',
      'We have to break',
      'Love while we break',
      'Love while I break',
      'Every day',
      'Don\'t negotiate with God',
      'The grain that dies bears much fruit',
      'God sees the break',
      'I surrender to You',
      'I hear You when I stop',
      'I waited for death',
      'I am not afraid',
      'Seeds have to break',
      'We have to break',
      'Love while we break',
      'Love while I break',
      'Every day',
      'I rise after the break',
      'No one is coming',
      'You know the shell',
      'Do good in secret',
      'I do the small work',
      'No one sees',
      'Love is truest',
      'Behind the mirror',
      'I want to be Yours',
      'Walk me through',
    ],
  },
  {
    slug: 'elevate-in-love',
    title: 'Elevate In Love',
    year: 2026,
    tagline: 'Elevate in love.',
    order: 1,
    video: '/media/videos/elevate-in-love.mp4?v=captioned',
    cover: '/media/covers/elevate-in-love.jpg?v=20261103',
    audio: '/stream/elevate-in-love.mp3',
    audioAlt: '/stream/elevate-in-love.m4a',
    mp3Label: 'AIAS - Elevate In Love (320kbps).mp3',
    lyrics: [
      'Elevate in love',
      '(yeah, elevate)',
      'Every day I’m still thinkin’ ’bout you',
      'Felt that throwback, saw you smilin’ through',
      'Retraced my steps, openin’ doors',
      'Caught you laughin’ at accents',
      'Handled my business, got my head right',
      'Two of the same can love, no fight',
      'American diner, London night',
      'You and I, face to face',
      'You ain’t never gotta open no door',
      'Ain’t no arguin’, not anymore',
      'Keep it steady, elevate from here',
      'Elevate in love',
      '(yeah, elevate)',
      'Step through the door, same two',
      'Different year, same hands',
      'We leave it better',
      'Back in the room',
      'Every day I’m still thinkin’ ’bout you',
      'Felt that throwback, saw you smilin’ through',
      'Retraced my steps, openin’ doors',
      'Caught you laughin’ at accents',
      'Handled my business, got my head right',
      'Two of the same can love, no fight',
      'American diner, London night',
      'You and I, face to face',
      'You ain’t never gotta open no door',
      'Ain’t no arguin’, not anymore',
      'Keep it steady, elevate from here',
      'Elevate in love',
      '(yeah, elevate)',
      'Elevate in love',
      '(yeah, elevate)',
      'Tu es mon âme et ma maison',
      'Mon beau garçon, mon grand amour',
      'On rentrera ensemble, au chaud',
      'Je t’attendrai, quoi qu’il en soit',
      'Tu as mon amour pour toujours',
      'Et tu l’auras chaque nouveau jour',
      'Dans la lumière, ensemble',
      'Pour tous les jours qui viennent',
    ],
  },
]

// Love Me In The Dark leads. Every other catalog title stays A–Z.
// These three stay off that list, in this order, on the Demo Archive page.
const FEATURED = 'love-me-in-the-dark'
const ARCHIVE_SLUGS = ['sunday-clothes', 'fuego-del-mundo', 'dear-him']

function byTitle(a: Song, b: Song) {
  if (a.slug === FEATURED) return -1
  if (b.slug === FEATURED) return 1
  return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
}

export const catalogSongs = songs
  .filter((song) => !ARCHIVE_SLUGS.includes(song.slug))
  .sort(byTitle)

export const archiveSongs = ARCHIVE_SLUGS.map((slug) => songs.find((song) => song.slug === slug)).filter(
  (song): song is Song => Boolean(song),
)

catalogSongs.forEach((song, i) => {
  song.order = i + 1
})
archiveSongs.forEach((song, i) => {
  song.order = i + 1
})

export function getSong(slug: string): Song | undefined {
  return songs.find((s) => s.slug === slug)
}

export function getAdjacent(slug: string): { prev?: Song; next?: Song } {
  const list = archiveSongs.some((song) => song.slug === slug) ? archiveSongs : catalogSongs
  const i = list.findIndex((song) => song.slug === slug)
  if (i < 0) return {}
  return {
    prev: i > 0 ? list[i - 1] : undefined,
    next: i < list.length - 1 ? list[i + 1] : undefined,
  }
}
